export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const EXCHANGE_TOKEN_REQUEST = 'EXCHANGE_TOKEN_REQUEST';
export const EXCHANGE_TOKEN_SUCCESS = 'EXCHANGE_TOKEN_SUCCESS';
export const EXCHANGE_TOKEN_FAILURE = 'EXCHANGE_TOKEN_FAILURE';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

export const LOGOUT = 'LOGOUT';

export const ASYNC_START = 'ASYNC_START';
export const ASYNC_END = 'ASYNC_END';

export const ADD_ABORT_CONTROLLER = 'ADD_ABORT_CONTROLLER';
export const CLEAR_ABORT_CONTROLLER = 'CLEAR_ABORT_CONTROLLER';

export const COUNTRIES_LOADED = 'COUNTRIES_LOADED';

export const GET_SERVICE_DATA_REQUEST = 'GET_SERVICE_DATA_REQUEST';
export const GET_SERVICE_DATA_SUCCESS = 'GET_SERVICE_DATA_SUCCESS';
export const GET_SERVICE_DATA_FAILURE = 'GET_SERVICE_DATA_FAILURE';
export const GET_TIMEZONES_DATA_REQUEST = 'GET_TIMEZONES_DATA_REQUEST';
export const GET_TIMEZONES_DATA_SUCCESS = 'GET_TIMEZONES_DATA_SUCCESS';
export const GET_TIMEZONES_DATA_FAILURE = 'GET_TIMEZONES_DATA_FAILURE';

export const GET_STATES_BY_COUNTRY_ID_REQUEST =
  'GET_STATES_BY_COUNTRY_ID_REQUEST';
export const GET_STATES_BY_COUNTRY_ID_SUCCESS =
  'GET_STATES_BY_COUNTRY_ID_SUCCESS';
export const GET_STATES_BY_COUNTRY_ID_FAILURE =
  'GET_STATES_BY_COUNTRY_ID_FAILURE';

export const BUILDING_REQUESTED = 'BUILDING_REQUESTED';

export const GET_BUILDINGS_LIST_REQUEST = 'GET_BUILDINGS_LIST_REQUEST';
export const GET_BUILDINGS_LIST_SUCCESS = 'GET_BUILDINGS_LIST_SUCCESS';
export const GET_BUILDINGS_LIST_FAILURE = 'GET_BUILDINGS_LIST_FAILURE';

export const GET_BUILDING_OPERATIONS_REQUEST =
  'GET_BUILDING_OPERATIONS_REQUEST';
export const GET_BUILDING_OPERATIONS_SUCCESS =
  'GET_BUILDING_OPERATIONS_SUCCESS';
export const GET_BUILDING_OPERATIONS_FAILURE =
  'GET_BUILDING_OPERATIONS_FAILURE';
export const UPDATE_BUILDING_OPERATIONS_REQUEST =
  'UPDATE_BUILDING_OPERATIONS_REQUEST';
export const UPDATE_BUILDING_OPERATIONS_SUCCESS =
  'UPDATE_BUILDING_OPERATIONS_SUCCESS';
export const UPDATE_BUILDING_OPERATIONS_FAILURE =
  'UPDATE_BUILDING_OPERATIONS_FAILURE';

export const DELETE_PICTURE_REQUEST = 'DELETE_PICTURE_REQUEST';
export const DELETE_PICTURE_SUCCESS = 'DELETE_PICTURE_SUCCESS';
export const DELETE_PICTURE_FAILURE = 'DELETE_PICTURE_FAILURE';

export const BUILDING_LIST_REQUESTED = 'BUILDING_LIST_REQUESTED';
export const CLEAR_BUILDING_LIST_REQUESTED = 'CLEAR_BUILDING_LIST_REQUESTED';
export const BUILDING_STAFF_REQUESTED = 'BUILDING_STAFF_REQUESTED';
export const BUILDING_RESIDENTS_REQUESTED = 'BUILDING_RESIDENTS_REQUESTED';

export const BUILDING_UNITS_REQUEST = 'BUILDING_UNITS_REQUEST';
export const BUILDING_UNITS_SUCCESS = 'BUILDING_UNITS_SUCCESS';
export const BUILDING_UNITS_FAILURE = 'BUILDING_UNITS_FAILURE';
export const BUILDING_CREATE_REQUESTED = 'BUILDING_CREATE_REQUESTED';
export const BUILDING_CREATE_SUCCEEDED = 'BUILDING_CREATE_SUCCEEDED';
export const BUILDING_CREATE_FAILURE = 'BUILDING_CREATE_FAILURE';
export const BUILDING_UPDATE_REQUESTED = 'BUILDING_UPDATE_REQUESTED';
export const BUILDING_UPDATE_SUCCEEDED = 'BUILDING_UPDATE_SUCCEEDED';
export const BUILDING_UPDATE_FAILURE = 'BUILDING_UPDATE_FAILURE';
export const BUILDING_DELETE_REQUEST = 'BUILDING_DELETE_REQUEST';
export const BUILDING_DELETE_SUCCESS = 'BUILDING_DELETE_SUCCESS';
export const BUILDING_DELETE_FAILURE = 'BUILDING_DELETE_FAILURE';

export const BUILDING_CREATE_SUBMITTED = 'BUILDING_CREATE_SUBMITTED';
export const BUILDING_SR_CATEGORIES_REQUESTED =
  'BUILDING_SR_CATEGORIES_REQUESTED';
export const BUILDING_YARDI_INFO_REQUESTED = 'BUILDING_YARDI_INFO_REQUESTED';

export const GET_BUILDING_STAFF_REQUEST = 'GET_BUILDING_STAFF_REQUEST';
export const GET_BUILDING_STAFF_SUCCESS = 'GET_BUILDING_STAFF_SUCCESS';
export const GET_BUILDING_STAFF_FAILURE = 'GET_BUILDING_STAFF_FAILURE';

export const GET_BUILDING_RESIDENT_REQUEST = 'GET_BUILDING_RESIDENT_REQUEST';
export const GET_BUILDING_RESIDENT_SUCCESS = 'GET_BUILDING_RESIDENT_SUCCESS';
export const GET_BUILDING_RESIDENT_FAILURE = 'GET_BUILDING_RESIDENT_FAILURE';
export const GET_BUILDING_RESIDENTS_REQUEST = 'GET_BUILDING_RESIDENTS_REQUEST';
export const GET_BUILDING_RESIDENTS_SUCCESS = 'GET_BUILDING_RESIDENTS_SUCCESS';
export const GET_BUILDING_RESIDENTS_FAILURE = 'GET_BUILDING_RESIDENTS_FAILURE';

export const GET_PERSON_DETAILS_REQUEST = 'GET_PERSON_DETAILS_REQUEST';
export const GET_PERSON_DETAILS_SUCCESS = 'GET_PERSON_DETAILS_SUCCESS';
export const GET_PERSON_DETAILS_FAILURE = 'GET_PERSON_DETAILS_FAILURE';

export const GET_PEOPLE_IN_BUILDING_SUCCESS = 'GET_PEOPLE_IN_BUILDING_SUCCESS';
export const GET_PEOPLE_IN_BUILDING_FAILURE = 'GET_PEOPLE_IN_BUILDING_FAILURE';

export const GET_BUILDING_SETTINGS_REQUEST = 'GET_BUILDING_SETTINGS_REQUEST';
export const GET_BUILDING_SETTINGS_SUCCESS = 'GET_BUILDING_SETTINGS_SUCCESS';
export const GET_BUILDING_SETTINGS_FAILURE = 'GET_BUILDING_SETTINGS_FAILURE';
export const PUT_BUILDING_SETTINGS_REQUEST = 'PUT_BUILDING_SETTINGS_REQUEST';
export const PUT_BUILDING_SETTINGS_SUCCESS = 'PUT_BUILDING_SETTINGS_SUCCESS';
export const PUT_BUILDING_SETTINGS_FAILURE = 'PUT_BUILDING_SETTINGS_FAILURE';

export const GET_PROPERTY_SETTINGS_REQUEST = 'GET_PROPERTY_SETTINGS_REQUEST';
export const GET_PROPERTY_SETTINGS_SUCCESS = 'GET_PROPERTY_SETTINGS_SUCCESS';
export const GET_PROPERTY_SETTINGS_FAILURE = 'GET_PROPERTY_SETTINGS_FAILURE';
export const PUT_PROPERTY_SETTINGS_REQUEST = 'PUT_PROPERTY_SETTINGS_REQUEST';
export const PUT_PROPERTY_SETTINGS_SUCCESS = 'PUT_PROPERTY_SETTINGS_SUCCESS';
export const PUT_PROPERTY_SETTINGS_FAILURE = 'PUT_PROPERTY_SETTINGS_FAILURE';

export const GET_LEASING_SETTINGS_REQUEST = 'GET_LEASING_SETTINGS_REQUEST';
export const GET_LEASING_SETTINGS_SUCCESS = 'GET_LEASING_SETTINGS_SUCCESS';
export const GET_LEASING_SETTINGS_FAILURE = 'GET_LEASING_SETTINGS_FAILURE';
export const PUT_LEASING_SETTINGS_REQUEST = 'PUT_LEASING_SETTINGS_REQUEST';
export const PUT_LEASING_SETTINGS_SUCCESS = 'PUT_LEASING_SETTINGS_SUCCESS';
export const PUT_LEASING_SETTINGS_FAILURE = 'PUT_LEASING_SETTINGS_FAILURE';

export const GET_REMOTE_DOORMAN_SETTINGS_REQUEST =
  'GET_REMOTE_DOORMAN_SETTINGS_REQUEST';
export const GET_REMOTE_DOORMAN_SETTINGS_SUCCESS =
  'GET_REMOTE_DOORMAN_SETTINGS_SUCCESS';
export const GET_REMOTE_DOORMAN_SETTINGS_FAILURE =
  'GET_REMOTE_DOORMAN_SETTINGS_FAILURE';
export const PUT_REMOTE_DOORMAN_SETTINGS_REQUEST =
  'PUT_REMOTE_DOORMAN_SETTINGS_REQUEST';
export const PUT_REMOTE_DOORMAN_SETTINGS_SUCCESS =
  'PUT_REMOTE_DOORMAN_SETTINGS_SUCCESS';
export const PUT_REMOTE_DOORMAN_SETTINGS_FAILURE =
  'PUT_REMOTE_DOORMAN_SETTINGS_FAILURE';

export const GET_DELIVERY_SNAPSHOT_DATA_REQUEST =
  'GET_DELIVERY_SNAPSHOT_DATA_REQUEST';
export const GET_DELIVERY_SNAPSHOT_DATA_SUCCESS =
  'GET_DELIVERY_SNAPSHOT_DATA_SUCCESS';
export const GET_DELIVERY_SNAPSHOT_DATA_FAILURE =
  'GET_DELIVERY_SNAPSHOT_DATA_FAILURE';
export const PUT_DELIVERY_SNAPSHOT_DATA_REQUEST =
  'PUT_DELIVERY_SNAPSHOT_DATA_REQUEST';
export const PUT_DELIVERY_SNAPSHOT_DATA_SUCCESS =
  'PUT_DELIVERY_SNAPSHOT_DATA_SUCCESS';
export const PUT_DELIVERY_SNAPSHOT_DATA_FAILURE =
  'PUT_DELIVERY_SNAPSHOT_DATA_FAILURE';

export const GET_INTEGRATIONS_STATUS_REQUEST =
  'GET_INTEGRATIONS_STATUS_REQUEST';
export const GET_INTEGRATIONS_STATUS_SUCCESS =
  'GET_INTEGRATIONS_STATUS_SUCCESS';
export const GET_INTEGRATIONS_STATUS_FAILURE =
  'GET_INTEGRATIONS_STATUS_FAILURE';
export const PUT_INTEGRATIONS_STATUS_REQUEST =
  'PUT_INTEGRATIONS_STATUS_REQUEST';
export const PUT_INTEGRATIONS_STATUS_SUCCESS =
  'PUT_INTEGRATIONS_STATUS_SUCCESS';
export const PUT_INTEGRATIONS_STATUS_FAILURE =
  'PUT_INTEGRATIONS_STATUS_FAILURE';
export const GET_DELIVERY_TYPES_REQUEST = 'GET_DELIVERY_TYPES_REQUEST';
export const GET_DELIVERY_TYPES_SUCCESS = 'GET_DELIVERY_TYPES_SUCCESS';
export const GET_DELIVERY_TYPES_FAILURE = 'GET_DELIVERY_TYPES_FAILURE';

export const GET_BUILDING_DELIVERY_TYPES_REQUEST =
  'GET_BUILDING_DELIVERY_TYPES_REQUEST';
export const GET_BUILDING_DELIVERY_TYPES_SUCCESS =
  'GET_BUILDING_DELIVERY_TYPES_SUCCESS';
export const GET_BUILDING_DELIVERY_TYPES_FAILURE =
  'GET_BUILDING_DELIVERY_TYPES_FAILURE';

export const PUT_BUILDING_DELIVERY_TYPES_REQUEST =
  'PUT_BUILDING_DELIVERY_TYPES_REQUEST';
export const PUT_BUILDING_DELIVERY_TYPES_SUCCESS =
  'PUT_BUILDING_DELIVERY_TYPES_SUCCESS';
export const PUT_BUILDING_DELIVERY_TYPES_FAILURE =
  'PUT_BUILDING_DELIVERY_TYPES_FAILURE';

export const GET_DELIVERY_TYPE_REQUEST = 'GET_DELIVERY_TYPE_REQUEST';
export const GET_DELIVERY_TYPE_SUCCESS = 'GET_DELIVERY_TYPE_SUCCESS';
export const GET_DELIVERY_TYPE_FAILURE = 'GET_DELIVERY_TYPE_FAILURE';
export const CREATE_DELIVERY_REQUEST = 'CREATE_DELIVERY_REQUEST';
export const CREATE_DELIVERY_SUCCESS = 'CREATE_DELIVERY_SUCCESS';
export const CREATE_DELIVERY_FAILURE = 'CREATE_DELIVERY_FAILURE';
export const UPDATE_DELIVERY_REQUEST = 'UPDATE_DELIVERY_REQUEST';
export const UPDATE_DELIVERY_SUCCESS = 'UPDATE_DELIVERY_SUCCESS';
export const UPDATE_DELIVERY_FAILURE = 'UPDATE_DELIVERY_FAILURE';
export const CREATE_DELIVERY_TYPE_REQUEST = 'CREATE_DELIVERY_TYPE_REQUEST';
export const CREATE_DELIVERY_TYPE_SUCCESS = 'CREATE_DELIVERY_TYPE_SUCCESS';
export const CREATE_DELIVERY_TYPE_FAILURE = 'CREATE_DELIVERY_TYPE_FAILURE';
export const UPDATE_DELIVERY_TYPE_REQUEST = 'UPDATE_DELIVERY_TYPE_REQUEST';
export const UPDATE_DELIVERY_TYPE_SUCCESS = 'UPDATE_DELIVERY_TYPE_SUCCESS';
export const UPDATE_DELIVERY_TYPE_FAILURE = 'UPDATE_DELIVERY_TYPE_FAILURE';
export const REMOVE_DELIVERY_TYPE_REQUEST = 'REMOVE_DELIVERY_TYPE_REQUEST';
export const REMOVE_DELIVERY_TYPE_SUCCESS = 'REMOVE_DELIVERY_TYPE_SUCCESS';
export const REMOVE_DELIVERY_TYPE_FAILURE = 'REMOVE_DELIVERY_TYPE_FAILURE';

export const GET_PERSON_BY_ID_REQUEST = 'GET_PERSON_BY_ID_REQUEST';
export const GET_PERSON_BY_ID_SUCCESS = 'GET_PERSON_BY_ID_SUCCESS';
export const GET_PERSON_BY_ID_FAILURE = 'GET_PERSON_BY_ID_FAILURE';
export const MANAGE_CREDENTIALS_REQUEST = 'MANAGE_CREDENTIALS_REQUEST';
export const MANAGE_CREDENTIALS_SUCCESS = 'MANAGE_CREDENTIALS_SUCCESS';
export const MANAGE_CREDENTIALS_FAILURE = 'MANAGE_CREDENTIALS_FAILURE';

export const SYNC_PERSON_WITH_BRIVO_REQUESTED =
  'SYNC_PERSON_WITH_BRIVO_REQUESTED';
export const SYNC_PERSON_WITH_BRIVO_SUCCEEDED =
  'SYNC_PERSON_WITH_BRIVO_SUCCEEDED';
export const SYNC_PERSON_WITH_BRIVO_FAILURE = 'SYNC_PERSON_WITH_BRIVO_FAILURE';

export const SYNC_PERSON_WITH_SMARTAIR = 'SYNC_PERSON_WITH_SMARTAIR';

export const SYNC_PERSON_WITH_BMX_REQUEST = 'SYNC_PERSON_WITH_BMX_REQUEST';
export const SYNC_PERSON_WITH_BMX_SUCCESS = 'SYNC_PERSON_WITH_BMX_SUCCESS';
export const SYNC_PERSON_WITH_BMX_FAILURE = 'SYNC_PERSON_WITH_BMX_FAILURE';
export const SYNC_ALL_PERSONS_WITH_BMX_REQUEST =
  'SYNC_ALL_PERSONS_WITH_BMX_REQUEST';
export const SYNC_ALL_PERSONS_WITH_BMX_SUCCESS =
  'SYNC_ALL_PERSONS_WITH_BMX_SUCCESS';
export const SYNC_ALL_PERSONS_WITH_BMX_FAILURE =
  'SYNC_ALL_PERSONS_WITH_BMX_FAILURE';
export const SYNC_RESIDENTS_FROM_YARDI_REQUEST =
  'SYNC_RESIDENTS_FROM_YARDI_REQUEST';
export const SYNC_RESIDENTS_FROM_YARDI_SUCCESS =
  'SYNC_RESIDENTS_FROM_YARDI_SUCCESS';
export const SYNC_RESIDENTS_FROM_YARDI_FAILURE =
  'SYNC_RESIDENTS_FROM_YARDI_FAILURE';
export const SYNC_DEVICES_REQUEST = 'SYNC_DEVICES_REQUEST';
export const SYNC_DEVICES_SUCCESS = 'SYNC_DEVICES_SUCCESS';
export const SYNC_DEVICES_FAILURE = 'SYNC_DEVICES_FAILURE';
export const SYNC_PERSONS_REQUEST = 'SYNC_PERSONS_REQUEST';
export const SYNC_PERSONS_SUCCESS = 'SYNC_PERSONS_SUCCESS';
export const SYNC_PERSONS_FAILURE = 'SYNC_PERSONS_FAILURE';
export const SYNC_PERSON_REQUEST = 'SYNC_PERSON_REQUEST';
export const SYNC_PERSON_SUCCESS = 'SYNC_PERSON_SUCCESS';
export const SYNC_PERSON_FAILURE = 'SYNC_PERSON_FAILURE';
export const SYNC_DORMAKABA_REQUEST = 'SYNC_DORMAKABA_REQUEST';
export const SYNC_DORMAKABA_SUCCESS = 'SYNC_DORMAKABA_SUCCESS';
export const SYNC_DORMAKABA_FAILURE = 'SYNC_DORMAKABA_FAILURE';

export const ADMIN_LIST_REQUESTED = 'ADMIN_LIST_REQUESTED';
export const GET_PERSON_LIST_REQUEST = 'GET_PERSON_LIST_REQUEST';
export const GET_PERSON_LIST_SUCCESS = 'GET_PERSON_LIST_SUCCESS';
export const GET_PERSON_LIST_FAILURE = 'GET_PERSON_LIST_FAILURE';
export const WIPE_PERSON_DATA_REQUEST = 'WIPE_PERSON_DATA_REQUEST';
export const WIPE_PERSON_DATA_SUCCESS = 'WIPE_PERSON_DATA_SUCCESS';
export const WIPE_PERSON_DATA_FAILURE = 'WIPE_PERSON_DATA_FAILURE';
export const ADMIN_REMOVE_REQUESTED = 'ADMIN_REMOVE_REQUESTED';
export const ADMIN_UPDATE_REQUESTED = 'ADMIN_UPDATE_REQUESTED';
export const ADMIN_CREATE_REQUESTED = 'ADMIN_CREATE_REQUESTED';

export const PMC_LIST_REQUESTED = 'PMC_LIST_REQUESTED';
export const PMC_REQUESTED = 'PMC_REQUESTED';
export const PMC_CREATE_REQUESTED = 'PMC_CREATE_REQUESTED';
export const PMC_CREATE_SUCCESS = 'PMC_CREATE_SUCCESS';
export const PMC_CREATE_FAILURE = 'PMC_CREATE_FAILURE';
export const PMC_UPDATE_REQUESTED = 'PMC_UPDATE_REQUESTED';
export const PMC_UPDATE_SUCCESS = 'PMC_UPDATE_SUCCESS';
export const PMC_UPDATE_FAILURE = 'PMC_UPDATE_FAILURE';
export const PMC_STAFF_REQUESTED = 'PMC_STAFF_REQUESTED';

export const DELETE_PMC_REQUEST = 'DELETE_PMC_REQUEST';
export const DELETE_PMC_SUCCESS = 'DELETE_PMC_SUCCESS';
export const DELETE_PMC_FAILURE = 'DELETE_PMC_FAILURE';

export const GET_PMCS_REQUEST = 'GET_PMCS_REQUEST';
export const GET_PMCS_SUCCESS = 'GET_PMCS_SUCCESS';
export const GET_PMCS_FAILURE = 'GET_PMCS_FAILURE';

export const GET_CAMERAS_REQUEST = 'GET_CAMERAS_REQUEST';
export const GET_CAMERAS_SUCCESS = 'GET_CAMERAS_SUCCESS';
export const GET_CAMERAS_FAILURE = 'GET_CAMERAS_FAILURE';

export const GET_PMC_STAFF_REQUEST = 'GET_PMC_STAFF_REQUEST';
export const GET_PMC_STAFF_SUCCESS = 'GET_PMC_STAFF_SUCCESS';
export const GET_PMC_STAFF_FAILURE = 'GET_PMC_STAFF_FAILURE';

export const CAMERAS_REORDER_REQUEST = 'CAMERAS_REORDER_REQUEST';
export const CAMERAS_REORDER_SUCCESS = 'CAMERAS_REORDER_SUCCESS';
export const CAMERAS_REORDER_FAILURE = 'CAMERAS_REORDER_FAILURE';

export const GET_ALL_SR_REQUEST = 'GET_ALL_SR_REQUEST';
export const GET_ALL_SR_SUCCESS = 'GET_ALL_SR_SUCCESS';
export const GET_ALL_SR_FAILURE = 'GET_ALL_SR_FAILURE';

export const GET_SR_CATEGORIES_REQUEST = 'GET_SR_CATEGORIES_REQUEST';
export const GET_SR_CATEGORIES_SUCCESS = 'GET_SR_CATEGORIES_SUCCESS';
export const GET_SR_CATEGORIES_FAILURE = 'GET_SR_CATEGORIES_FAILURE';

export const SR_CATEGORIES_DELETE_REQUEST = 'SR_CATEGORIES_DELETE_REQUEST';
export const SR_CATEGORIES_DELETE_SUCCESS = 'SR_CATEGORIES_DELETE_SUCCESS';
export const SR_CATEGORIES_DELETE_FAILURE = 'SR_CATEGORIES_DELETE_FAILURE';

export const SR_CATEGORIES_UPDATE_REQUEST = 'SR_CATEGORIES_UPDATE_REQUEST';
export const SR_CATEGORIES_UPDATE_SUCCESS = 'SR_CATEGORIES_UPDATE_SUCCESS';
export const SR_CATEGORIES_UPDATE_FAILURE = 'SR_CATEGORIES_UPDATE_FAILURE';

export const SR_CATEGORIES_CREATE_REQUESTED = 'SR_CATEGORIES_CREATE_REQUESTED';
export const SR_CATEGORIES_CREATE_SUCCESS = 'SR_CATEGORIES_CREATE_SUCCESS';
export const SR_CATEGORIES_CREATE_FAILURE = 'SR_CATEGORIES_CREATE_FAILURE';

export const STAFF_CREATE_REQUESTED = 'STAFF_CREATE_REQUESTED';
export const STAFF_UPDATE_REQUESTED = 'STAFF_UPDATE_REQUESTED';

export const STAFF_MOVE_OUT_REQUEST = 'STAFF_MOVE_OUT_REQUEST';
export const STAFF_MOVE_OUT_SUCCESS = 'STAFF_MOVE_OUT_SUCCESS';
export const STAFF_MOVE_OUT_FAILURE = 'STAFF_MOVE_OUT_FAILURE';

export const RESIDENT_CREATE_REQUEST = 'RESIDENT_CREATE_REQUEST';
export const RESIDENT_CREATE_SUCCESS = 'RESIDENT_CREATE_SUCCESS';
export const RESIDENT_CREATE_FAILURE = 'RESIDENT_CREATE_FAILURE';
export const RESIDENT_UPDATE_REQUEST = 'RESIDENT_UPDATE_REQUEST';
export const RESIDENT_UPDATE_SUCCESS = 'RESIDENT_UPDATE_SUCCESS';
export const RESIDENT_UPDATE_FAILURE = 'RESIDENT_UPDATE_FAILURE';

export const SET_SKIP_MOVE_IN_REQUEST = 'SET_SKIP_MOVE_IN_REQUEST';
export const SET_SKIP_MOVE_IN_SUCCESS = 'SET_SKIP_MOVE_IN_SUCCESS';
export const SET_SKIP_MOVE_IN_FAILURE = 'SET_SKIP_MOVE_IN_FAILURE';

export const ADD_PAYMENT_PROVIDER_REQUEST = 'ADD_PAYMENT_PROVIDER_REQUEST';
export const ADD_PAYMENT_PROVIDER_SUCCESS = 'ADD_PAYMENT_PROVIDER_SUCCESS';
export const ADD_PAYMENT_PROVIDER_FAILURE = 'ADD_PAYMENT_PROVIDER_FAILURE';

export const RESIDENT_MOVE_OUT_REQUEST = 'RESIDENT_MOVE_OUT_REQUEST';
export const RESIDENT_MOVE_OUT_SUCCESS = 'RESIDENT_MOVE_OUT_SUCCESS';
export const RESIDENT_MOVE_OUT_FAILURE = 'RESIDENT_MOVE_OUT_FAILURE';

export const PERSON_ACTIVITY_REQUEST = 'PERSON_ACTIVITY_REQUEST';
export const PERSON_ACTIVITY_SUCCESS = 'PERSON_ACTIVITY_SUCCESS';
export const PERSON_ACTIVITY_FAILURE = 'PERSON_ACTIVITY_FAILURE';

export const GET_PERSON_NOTIFICATIONS_REQUEST =
  'GET_PERSON_NOTIFICATIONS_REQUEST';
export const GET_PERSON_NOTIFICATIONS_SUCCESS =
  'GET_PERSON_NOTIFICATIONS_SUCCESS';
export const GET_PERSON_NOTIFICATIONS_FAILURE =
  'GET_PERSON_NOTIFICATIONS_FAILURE';

export const PERSON_ACTIVITY_OVERVIEW_REQUEST =
  'PERSON_ACTIVITY_OVERVIEW_REQUEST';
export const PERSON_ACTIVITY_OVERVIEW_SUCCESS =
  'PERSON_ACTIVITY_OVERVIEW_SUCCESS';
export const PERSON_ACTIVITY_OVERVIEW_FAILURE =
  'PERSON_ACTIVITY_OVERVIEW_FAILURE';
export const REMOVE_RESIDENT_ROLE_REQUEST = 'REMOVE_RESIDENT_ROLE_REQUEST';
export const REMOVE_RESIDENT_ROLE_SUCCESS = 'REMOVE_RESIDENT_ROLE_SUCCESS';
export const REMOVE_RESIDENT_ROLE_FAILURE = 'REMOVE_RESIDENT_ROLE_FAILURE';
export const IMPORT_RESIDENT_REQUEST = 'IMPORT_RESIDENT_REQUEST';
export const IMPORT_RESIDENT_SUCCESS = 'IMPORT_RESIDENT_SUCCESS';
export const IMPORT_RESIDENT_FAILURE = 'IMPORT_RESIDENT_FAILURE';

export const RESEND_INVITE_TO_ALL_RESIDENTS_REQUEST =
  'RESEND_INVITE_TO_ALL_RESIDENTS_REQUEST';
export const RESEND_INVITE_TO_ALL_RESIDENTS_SUCCESS =
  'RESEND_INVITE_TO_ALL_RESIDENTS_SUCCESS';
export const RESEND_INVITE_TO_ALL_RESIDENTS_FAILURE =
  'RESEND_INVITE_TO_ALL_RESIDENTS_FAILURE';
export const RESEND_INVITE_TO_ALL_RESIDENTS_INFO_REQUEST =
  'RESEND_INVITE_TO_ALL_RESIDENTS_INFO_REQUEST';
export const RESEND_INVITE_TO_ALL_RESIDENTS_INFO_SUCCESS =
  'RESEND_INVITE_TO_ALL_RESIDENTS_INFO_SUCCESS';
export const RESEND_INVITE_TO_ALL_RESIDENTS_INFO_FAILURE =
  'RESEND_INVITE_TO_ALL_RESIDENTS_INFO_FAILURE';

export const RESEND_BMX_INVITE_REQUEST = 'RESEND_BMX_INVITE_REQUEST';
export const RESEND_BMX_INVITE_SUCCESS = 'RESEND_BMX_INVITE_SUCCESS';
export const RESEND_BMX_INVITE_FAILURE = 'RESEND_BMX_INVITE_FAILURE';

export const GET_BMX_REGISTRATION_STATUS_REQUEST =
  'GET_BMX_REGISTRATION_STATUS_REQUEST';
export const GET_BMX_REGISTRATION_STATUS_SUCCESS =
  'GET_BMX_REGISTRATION_STATUS_SUCCESS';
export const GET_BMX_REGISTRATION_STATUS_FAILURE =
  'GET_BMX_REGISTRATION_STATUS_FAILURE';

export const UNITS_ORDERING_SUBMITTED = 'UNITS_ORDERING_SUBMITTED';
export const UNITS_CREATE_REQUESTED = 'UNITS_CREATE_REQUESTED';
export const UNIT_REMOVE_REQUESTED = 'UNIT_REMOVE_REQUESTED';
export const UNIT_UPDATE_REQUESTED = 'UNIT_UPDATE_REQUESTED';
export const UNIT_REMOVE_SUCCEEDED = 'UNIT_REMOVE_SUCCEEDED';
export const UNIT_RESIDENTS_REQUESTED = 'UNIT_RESIDENTS_REQUESTED';
export const GET_UNIT_REQUEST = 'GET_UNIT_REQUEST';
export const GET_UNIT_SUCCESS = 'GET_UNIT_SUCCESS';
export const GET_UNIT_FAILURE = 'GET_UNIT_FAILURE';
export const GET_UNITS_WITH_CONTACTS_REQUEST =
  'GET_UNITS_WITH_CONTACTS_REQUEST';
export const GET_UNITS_WITH_CONTACTS_SUCCESS =
  'GET_UNITS_WITH_CONTACTS_SUCCESS';
export const GET_UNITS_WITH_CONTACTS_FAILURE =
  'GET_UNITS_WITH_CONTACTS_FAILURE';
export const CREATE_UNITS_REQUEST = 'CREATE_UNITS_REQUEST';
export const CREATE_UNITS_SUCCESS = 'CREATE_UNITS_SUCCESS';
export const CREATE_UNITS_FAILURE = 'CREATE_UNITS_FAILURE';
export const UPDATE_UNIT_REQUEST = 'UPDATE_UNIT_REQUEST';
export const UPDATE_UNIT_SUCCESS = 'UPDATE_UNIT_SUCCESS';
export const UPDATE_UNIT_FAILURE = 'UPDATE_UNIT_FAILURE';
export const GET_UNIT_ACTIVITY_OVERVIEW_REQUEST =
  'GET_UNIT_ACTIVITY_OVERVIEW_REQUEST';
export const GET_UNIT_ACTIVITY_OVERVIEW_SUCCESS =
  'GET_UNIT_ACTIVITY_OVERVIEW_SUCCESS';
export const GET_UNIT_ACTIVITY_OVERVIEW_FAILURE =
  'GET_UNIT_ACTIVITY_OVERVIEW_FAILURE';
export const SEARCH_UNITS_REQUEST = 'SEARCH_UNITS_REQUEST';
export const SEARCH_UNITS_SUCCESS = 'SEARCH_UNITS_SUCCESS';
export const SEARCH_UNITS_FAILURE = 'SEARCH_UNITS_FAILURE';

export const GET_YARDI_UNITS_REQUEST = 'GET_YARDI_UNITS_REQUEST';
export const GET_YARDI_UNITS_SUCCESS = 'GET_YARDI_UNITS_SUCCESS';
export const GET_YARDI_UNITS_FAILURE = 'GET_YARDI_UNITS_FAILURE';
export const GET_YARDI_STATUSES_REQUEST = 'GET_YARDI_STATUSES_REQUEST';
export const GET_YARDI_STATUSES_SUCCESS = 'GET_YARDI_STATUSES_SUCCESS';
export const GET_YARDI_STATUSES_FAILURE = 'GET_YARDI_STATUSES_FAILURE';
export const SYNC_YARDI_SR_AND_RESIDENTS_REQUEST =
  'SYNC_YARDI_SR_AND_RESIDENTS_REQUEST';
export const SYNC_YARDI_SR_AND_RESIDENTS_SUCCESS =
  'SYNC_YARDI_SR_AND_RESIDENTS_SUCCESS';
export const SYNC_YARDI_SR_AND_RESIDENTS_FAILURE =
  'SYNC_YARDI_SR_AND_RESIDENTS_FAILURE';
export const SYNC_YARDI_SR_CATEGORIES_REQUEST =
  'SYNC_YARDI_SR_CATEGORIES_REQUEST';
export const SYNC_YARDI_SR_CATEGORIES_SUCCESS =
  'SYNC_YARDI_SR_CATEGORIES_SUCCESS';
export const SYNC_YARDI_SR_CATEGORIES_FAILURE =
  'SYNC_YARDI_SR_CATEGORIES_FAILURE';

export const CLEAR_UNITS = 'CLEAR_UNITS';

export const GET_QR_CODE_REQUEST = 'GET_QR_CODE_REQUEST';
export const GET_QR_CODE_SUCCESS = 'GET_QR_CODE_SUCCESS';
export const GET_QR_CODE_FAILURE = 'GET_QR_CODE_FAILURE';

export const FORGOT_PASSWORD_REQUESTED = 'FORGOT_PASSWORD_REQUESTED';
export const FORGOT_PASSWORD_SUCCEEDED = 'FORGOT_PASSWORD_SUCCEEDED';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const SOCIAL_SIGNUP_REQUEST = 'SOCIAL_SIGNUP_REQUEST';
export const SOCIAL_SIGNUP_SUCCESS = 'SOCIAL_SIGNUP_SUCCESS';
export const SOCIAL_SIGNUP_FAILURE = 'SOCIAL_SIGNUP_FAILURE';

export const VERIFY_REQUEST = 'VERIFY_REQUEST';
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS';
export const VERIFY_FAILURE = 'VERIFY_FAILURE';

export const GET_REGISTERED_USER_DATA_REQUEST =
  'GET_REGISTERED_USER_DATA_REQUEST';
export const GET_REGISTERED_USER_DATA_SUCCESS =
  'GET_REGISTERED_USER_DATA_SUCCESS';
export const GET_REGISTERED_USER_DATA_FAILURE =
  'GET_REGISTERED_USER_DATA_FAILURE';

export const SAVE_BRANCH_DATA = 'SAVE_BRANCH_DATA';
export const DELETE_BRANCH_DATA = 'DELETE_BRANCH_DATA';

export const AUTH_SET_PASSWORD = 'AUTH_SET_PASSWORD';
export const ADMIN_INVITE_RESENT = 'ADMIN_INVITE_RESENT';
export const PERSON_INVITE_RESENT = 'PERSON_INVITE_RESENT';

export const TOGGLE_IS_NAVIGATION_SHOWN = 'TOGGLE_IS_NAVIGATION_SHOWN';

export const CALL_CENTER_DASHBOARD_LOADED = 'CALL_CENTER_DASHBOARD_LOADED';
export const OPEN_DOOR = 'OPEN_DOOR';
export const VISITOR_CREATE_SUBMITTED = 'VISITOR_CREATE_SUBMITTED';
export const DELIVERY_CREATE_TOGGLE = 'DELIVERY_CREATE_TOGGLE';
export const SET_CALL_CENTER_MODAL_TYPE = 'SET_CALL_CENTER_MODAL_TYPE';
export const VISITOR_REJECT_SUBMITTED = 'VISITOR_REJECT_SUBMITTED';
export const CALL_CENTER_NO_ACTION = 'CALL_CENTER_NO_ACTION';
export const TOGGLE_CUSTOM_MODAL = 'TOGGLE_CUSTOM_MODAL';
export const SET_PROGRESS_VALUE = 'SET_PROGRESS_VALUE';

export const UPDATE_CURRENT_PERSON = 'UPDATE_CURRENT_PERSON';

export const EE_SESSION_REFRESHED = 'EE_SESSION_REFRESHED';
export const EE_BUILDING_SESSION_REQUESTED = 'EE_BUILDING_SESSION_REQUESTED';
export const EE_BUILDING_SESSION_SUCCEEDED = 'EE_BUILDING_SESSION_SUCCEEDED';
export const EE_BUILDING_SESSION_FAILURE = 'EE_BUILDING_SESSION_FAILURE';
export const EE_BUILDING_SESSION_FINISHED = 'EE_BUILDING_SESSION_FINISHED';

export const NOTIFY_SUCCESS = 'NOTIFY_SUCCESS';
export const NOTIFY_WARNING = 'NOTIFY_WARNING';
export const CLEAR_POPUP = 'CLEAR_POPUP';

export const SET_MODAL_TYPE = 'SET_MODAL_TYPE';

export const SELECT_EXISTING_LOAD_PEOPLE = 'SELECT_EXISTING_LOAD_PEOPLE';
export const SELECT_EXISTING_CLEAR_PEOPLE = 'SELECT_EXISTING_CLEAR_PEOPLE';

export const ALL_ACCESS_POINTS_LIST_REQUESTED =
  'ALL_ACCESS_POINTS_LIST_REQUESTED';

export const ACCESS_POINTS_LIST_REQUESTED = 'ACCESS_POINTS_LIST_REQUESTED';
export const ACCESS_POINTS_LIST_SUCCEEDED = 'ACCESS_POINTS_LIST_SUCCEEDED';
export const ACCESS_POINTS_LIST_FAILURE = 'ACCESS_POINTS_LIST_FAILURE';

export const ACCESS_POINT_UPDATE_REQUESTED = 'ACCESS_POINT_UPDATE_REQUESTED';
export const ACCESS_POINT_UPDATE_SUCCEEDED = 'ACCESS_POINT_UPDATE_SUCCEEDED';
export const ACCESS_POINT_UPDATE_FAILURE = 'ACCESS_POINT_UPDATE_FAILURE';

export const ACCESS_POINT_CREATE_REQUESTED = 'ACCESS_POINT_CREATE_REQUESTED';
export const ACCESS_POINT_CREATE_SUCCEEDED = 'ACCESS_POINT_CREATE_SUCCEEDED';
export const ACCESS_POINT_CREATE_FAILURE = 'ACCESS_POINT_CREATE_FAILURE';

export const GET_DOORS_REQUEST = 'GET_DOORS_REQUEST';
export const GET_DOORS_SUCCESS = 'GET_DOORS_SUCCESS';
export const GET_DOORS_FAILURE = 'GET_DOORS_FAILURE';

export const GET_DOOR_REQUEST = 'GET_DOOR_REQUEST';
export const GET_DOOR_SUCCESS = 'GET_DOOR_SUCCESS';
export const GET_DOOR_FAILURE = 'GET_DOOR_FAILURE';

export const GET_DOORS_OPENING_LOG_REQUEST = 'GET_DOORS_OPENING_LOG_REQUEST';
export const GET_DOORS_OPENING_LOG_SUCCESS = 'GET_DOORS_OPENING_LOG_SUCCESS';
export const GET_DOORS_OPENING_LOG_FAILURE = 'GET_DOORS_OPENING_LOG_FAILURE';

export const DOORS_REORDER_REQUEST = 'DOORS_REORDER_REQUEST';
export const DOORS_REORDER_SUCCESS = 'DOORS_REORDER_SUCCESS';
export const DOORS_REORDER_FAILURE = 'DOORS_REORDER_FAILURE';

export const DOOR_UPDATE_REQUESTED = 'DOOR_UPDATE_REQUESTED';
export const DOOR_UPDATE_SUCCEEDED = 'DOOR_UPDATE_SUCCEEDED';
export const DOOR_UPDATE_FAILURE = 'DOOR_UPDATE_FAILURE';

export const DOOR_CREATE_REQUESTED = 'DOOR_CREATE_REQUESTED';
export const DOOR_CREATE_SUCCEEDED = 'DOOR_CREATE_SUCCEEDED';
export const DOOR_CREATE_FAILURE = 'DOOR_CREATE_FAILURE';

export const DOOR_DELETE_REQUEST = 'DOOR_DELETE_REQUEST';
export const DOOR_DELETE_SUCCESS = 'DOOR_DELETE_SUCCESS';
export const DOOR_DELETE_FAILURE = 'DOOR_DELETE_FAILURE';

export const GET_AP_DEVICE_MODELS_REQUEST = 'GET_AP_DEVICE_MODELS_REQUEST';
export const GET_AP_DEVICE_MODELS_SUCCESS = 'GET_AP_DEVICE_MODELS_SUCCESS';
export const GET_AP_DEVICE_MODELS_FAILURE = 'GET_AP_DEVICE_MODELS_FAILURE';

export const ON_DOOR_SCHEDULE_CHANGE_REQUEST =
  'ON_DOOR_SCHEDULE_CHANGE_REQUEST';
export const ON_DOOR_SCHEDULE_CHANGE_SUCCESS =
  'ON_DOOR_SCHEDULE_CHANGE_SUCCESS';
export const ON_DOOR_SCHEDULE_CHANGE_FAILURE =
  'ON_DOOR_SCHEDULE_CHANGE_FAILURE';

export const GET_DELIVERY_LIST_REQUEST = 'GET_DELIVERY_LIST_REQUEST';
export const GET_DELIVERY_LIST_SUCCESS = 'GET_DELIVERY_LIST_SUCCESS';
export const GET_DELIVERY_LIST_FAILURE = 'GET_DELIVERY_LIST_FAILURE';

export const DELIVERIES_SIGN_OUT_REQUEST = 'DELIVERIES_SIGN_OUT_REQUEST';
export const DELIVERIES_SIGN_OUT_SUCCESS = 'DELIVERIES_SIGN_OUT_SUCCESS';
export const DELIVERIES_SIGN_OUT_FAILURE = 'DELIVERIES_SIGN_OUT_FAILURE';

export const GET_SERVICE_REQUEST_REQUEST = 'GET_SERVICE_REQUEST_REQUEST';
export const GET_SERVICE_REQUEST_SUCCESS = 'GET_SERVICE_REQUEST_SUCCESS';
export const GET_SERVICE_REQUEST_FAILURE = 'GET_SERVICE_REQUEST_FAILURE';

export const SERVICE_REQUESTS_UNIT_FAILURE = 'SERVICE_REQUESTS_UNIT_FAILURE';
export const SERVICE_REQUESTS_UNIT_REQUEST = 'SERVICE_REQUESTS_UNIT_REQUEST';
export const SERVICE_REQUESTS_UNIT_SUCCESS = 'SERVICE_REQUESTS_UNIT_SUCCESS';

export const GET_SERVICE_REQUESTS_IDS_REQUEST =
  'GET_SERVICE_REQUESTS_IDS_REQUEST';
export const GET_SERVICE_REQUESTS_IDS_SUCCESS =
  'GET_SERVICE_REQUESTS_IDS_SUCCESS';
export const GET_SERVICE_REQUESTS_IDS_FAILURE =
  'GET_SERVICE_REQUESTS_IDS_FAILURE';
export const GET_SERVICE_REQUESTS_PRIORITIES_REQUEST =
  'GET_SERVICE_REQUESTS_PRIORITIES_REQUEST';
export const GET_SERVICE_REQUESTS_PRIORITIES_SUCCESS =
  'GET_SERVICE_REQUESTS_PRIORITIES_SUCCESS';
export const GET_SERVICE_REQUESTS_PRIORITIES_FAILURE =
  'GET_SERVICE_REQUESTS_PRIORITIES_FAILURE';

export const CLEAR_SERVICE_REQUEST = 'CLEAR_SERVICE_REQUEST';

export const SERVICE_REQUEST_UPDATE_REQUESTED =
  'SERVICE_REQUEST_UPDATE_REQUESTED';

export const CREATE_SERVICE_REQUEST_REQUEST = 'CREATE_SERVICE_REQUEST_REQUEST';
export const CREATE_SERVICE_REQUEST_SUCCESS = 'CREATE_SERVICE_REQUEST_SUCCESS';
export const CREATE_SERVICE_REQUEST_FAILURE = 'CREATE_SERVICE_REQUEST_FAILURE';

export const SERVICE_REQUEST_CATEGORIES_REQUESTED =
  'SERVICE_REQUEST_CATEGORIES_REQUESTED';
export const SERVICE_REQUEST_COMMENTS_REQUESTED =
  'SERVICE_REQUEST_COMMENTS_REQUESTED';
export const SERVICE_REQUESTS_COUNTS_REQUEST =
  'SERVICE_REQUESTS_COUNTS_REQUEST';
export const SERVICE_REQUESTS_COUNTS_SUCCESS =
  'SERVICE_REQUESTS_COUNTS_SUCCESS';
export const SERVICE_REQUESTS_COUNTS_FAILURE =
  'SERVICE_REQUESTS_COUNTS_FAILURE';

export const SERVICE_REQUESTS_REQUEST = 'SERVICE_REQUESTS_REQUEST';
export const SERVICE_REQUESTS_SUCCESS = 'SERVICE_REQUESTS_SUCCESS';
export const SERVICE_REQUESTS_FAILURE = 'SERVICE_REQUESTS_FAILURE';

export const GET_SERVICE_REQUEST_STATUSES_REQUEST =
  'GET_SERVICE_REQUEST_STATUSES_REQUEST';
export const GET_SERVICE_REQUEST_STATUSES_SUCCESS =
  'GET_SERVICE_REQUEST_STATUSES_SUCCESS';
export const GET_SERVICE_REQUEST_STATUSES_FAILURE =
  'GET_SERVICE_REQUEST_STATUSES_FAILURE';

export const GET_VISITORS_LOG_REQUEST = 'GET_VISITORS_LOG_REQUEST';
export const GET_VISITORS_LOG_SUCCESS = 'GET_VISITORS_LOG_SUCCESS';
export const GET_VISITORS_LOG_FAILURE = 'GET_VISITORS_LOG_FAILURE';

export const LOG_VISITOR_ENTRY_REQUEST = 'LOG_VISITOR_ENTRY_REQUEST';
export const LOG_VISITOR_ENTRY_SUCCESS = 'LOG_VISITOR_ENTRY_SUCCESS';
export const LOG_VISITOR_ENTRY_FAILURE = 'LOG_VISITOR_ENTRY_FAILURE';

export const GET_VISITOR_INFO_BY_ID_REQUEST = 'GET_VISITOR_INFO_BY_ID_REQUEST';
export const GET_VISITOR_INFO_BY_ID_SUCCESS = 'GET_VISITOR_INFO_BY_ID_SUCCESS';
export const GET_VISITOR_INFO_BY_ID_FAILURE = 'GET_VISITOR_INFO_BY_ID_FAILURE';
export const GET_VISITORS_REQUESTED = 'GET_VISITORS_REQUESTED';
export const GET_VISITORS_SUCCEEDED = 'GET_VISITORS_SUCCEEDED';
export const GET_VISITORS_FAILURE = 'GET_VISITORS_FAILURE';
export const GET_VISITOR_INFO_BY_CREATOR_ID_REQUEST =
  'GET_VISITOR_INFO_BY_CREATOR_ID_REQUEST';
export const GET_VISITOR_INFO_BY_CREATOR_ID_SUCCESS =
  'GET_VISITOR_INFO_BY_CREATOR_ID_SUCCESS';
export const GET_VISITOR_INFO_BY_CREATOR_ID_FAILURE =
  'GET_VISITOR_INFO_BY_CREATOR_ID_FAILURE';
export const SET_NEW_VISITOR_REQUESTED = 'SET_NEW_VISITOR_REQUESTED';
export const SET_NEW_VISITOR_SUCCEEDED = 'SET_NEW_VISITOR_SUCCEEDED';
export const SET_NEW_VISITOR_FAILURE = 'SET_NEW_VISITOR_FAILURE';
export const UPDATE_NEW_VISITOR_REQUESTED = 'UPDATE_NEW_VISITOR_REQUESTED';
export const UPDATE_NEW_VISITOR_SUCCEEDED = 'UPDATE_NEW_VISITOR_SUCCEEDED';
export const UPDATE_NEW_VISITOR_FAILURE = 'UPDATE_NEW_VISITOR_FAILURE';
export const EXPIRE_VISITORS_REQUESTED = 'EXPIRE_VISITORS_REQUESTED';
export const EXPIRE_VISITORS_SUCCEEDED = 'EXPIRE_VISITORS_SUCCEEDED';
export const EXPIRE_VISITORS_FAILURE = 'EXPIRE_VISITORS_FAILURE';
export const VISITOR_INVITE_SEND = 'VISITOR_INVITE_SEND';
export const VISITOR_INVITE_RESEND = 'VISITOR_INVITE_RESEND';
export const VISITOR_INVITE_DELETE = 'VISITOR_INVITE_DELETE';
export const GET_INVITE_INFO_REQUEST = 'GET_INVITE_INFO_REQUEST';
export const GET_INVITE_INFO_SUCCESS = 'GET_INVITE_INFO_SUCCESS';
export const GET_INVITE_INFO_FAILURE = 'GET_INVITE_INFO_FAILURE';
export const UPDATE_INVITE_INFO_REQUEST = 'UPDATE_INVITE_INFO_REQUEST';
export const UPDATE_INVITE_INFO_SUCCESS = 'UPDATE_INVITE_INFO_SUCCESS';
export const UPDATE_INVITE_INFO_FAILURE = 'UPDATE_INVITE_INFO_FAILURE';
export const CLEAR_INVITE_INFO = 'CLEAR_INVITE_INFO';

export const CREATE_CAMERA_REQUEST = 'CREATE_CAMERA_REQUEST';
export const CREATE_CAMERA_SUCCESS = 'CREATE_CAMERA_SUCCESS';
export const CREATE_CAMERA_FAILURE = 'CREATE_CAMERA_FAILURE';
export const DELETE_CAMERA_REQUEST = 'DELETE_CAMERA_REQUEST';
export const DELETE_CAMERA_SUCCESS = 'DELETE_CAMERA_SUCCESS';
export const DELETE_CAMERA_FAILURE = 'DELETE_CAMERA_FAILURE';
export const CAMERA_UPDATE_REQUESTED = 'CAMERA_UPDATE_REQUESTED';
export const CONFIRM_CONTACT_INFO = 'CONFIRM_CONTACT_INFO';
export const YARDI_RESYNC_REQUESTED = 'YARDI_RESYNC_REQUESTED';

export const UPLOAD_FILES_REQUEST = 'UPLOAD_FILES_REQUEST';
export const UPLOAD_FILES_SUCCESS = 'UPLOAD_FILES_SUCCESS';
export const UPLOAD_FILES_FAILURE = 'UPLOAD_FILES_FAILURE';

export const SET_LIST_PARAMS = 'SET_LIST_PARAMS';

export const IP_LIST_REQUESTED = 'IP_LIST_REQUESTED';
export const IP_CREATE_REQUESTED = 'IP_CREATE_REQUESTED';
export const IP_UPDATE_REQUESTED = 'IP_UPDATE_REQUESTED';
export const IP_DELETE_REQUESTED = 'IP_DELETE_REQUESTED';
export const IP_DELETE_SUCCEEDED = 'IP_DELETE_SUCCEEDED';

export const GET_CHATS_REQUESTED = 'GET_CHATS_REQUESTED';
export const GET_CHATS_SUCCESS = 'GET_CHATS_SUCCESS';
export const GET_CHATS_FAILURE = 'GET_CHATS_FAILURE';
export const GET_CHAT_BY_ID_REQUESTED = 'GET_CHAT_BY_ID_REQUESTED';
export const GET_CHAT_BY_ID_SUCCESS = 'GET_CHAT_BY_ID_SUCCESS';
export const GET_CHAT_BY_ID_FAILURE = 'GET_CHAT_BY_ID_FAILURE';

export const MARK_CHAT_AS_READ_REQUESTED = 'MARK_CHAT_AS_READ_REQUESTED';
export const MARK_CHAT_AS_READ_SUCCESS = 'MARK_CHAT_AS_READ_SUCCESS';
export const MARK_CHAT_AS_READ_FAILURE = 'MARK_CHAT_AS_READ_FAILURE';
export const PUT_NEW_MESSAGE_REQUESTED = 'PUT_NEW_MESSAGE_REQUESTED';
export const PUT_NEW_MESSAGE_SUCCESS = 'PUT_NEW_MESSAGE_SUCCESS';
export const PUT_NEW_MESSAGE_FAILURE = 'PUT_NEW_MESSAGE_FAILURE';
export const GET_RECIPIENTS_REQUESTED = 'GET_RECIPIENTS_REQUESTED';
export const GET_RECIPIENTS_SUCCESS = 'GET_RECIPIENTS_SUCCESS';
export const GET_RECIPIENTS_FAILURE = 'GET_RECIPIENTS_FAILURE';
export const CLEAR_RECIPIENTS_REQUESTED = 'CLEAR_RECIPIENTS_REQUESTED';

export const GET_THREADS_SCOPES_REQUEST = 'GET_THREADS_SCOPES_REQUEST';
export const GET_THREADS_SCOPES_SUCCESS = 'GET_THREADS_SCOPES_SUCCESS';
export const GET_THREADS_SCOPES_FAILURE = 'GET_THREADS_SCOPES_FAILURE';

export const CREATE_THREAD_REQUESTED = 'CREATE_THREAD_REQUESTED';
export const CREATE_THREAD_SUCCESS = 'CREATE_THREAD_SUCCESS';
export const CREATE_THREAD_FAILURE = 'CREATE_THREAD_FAILURE';
export const HANDLE_NEW_CHAT_CREATION_REQUESTED =
  'HANDLE_NEW_CHAT_CREATION_REQUESTED';
export const CANCEL_NEW_CHAT_CREATION_REQUESTED =
  'CANCEL_NEW_CHAT_CREATION_REQUESTED';
export const GET_NUMBER_OF_RECIPIENTS_REQUESTED =
  'GET_NUMBER_OF_RECIPIENTS_REQUESTED';
export const GET_NUMBER_OF_RECIPIENTS_SUCCESS =
  'GET_NUMBER_OF_RECIPIENTS_SUCCESS';
export const GET_NUMBER_OF_RECIPIENTS_FAILURE =
  'GET_NUMBER_OF_RECIPIENTS_FAILURE';
export const GET_CHAT_INFO_BY_ID_REQUEST = 'GET_CHAT_INFO_BY_ID_REQUEST';
export const GET_CHAT_INFO_BY_ID_SUCCESS = 'GET_CHAT_INFO_BY_ID_SUCCESS';
export const GET_CHAT_INFO_BY_ID_FAILURE = 'GET_CHAT_INFO_BY_ID_FAILURE';

export const SET_DOCUMENT_AS_ATTACHMENT = 'SET_DOCUMENT_AS_ATTACHMENT';

export const SET_NEW_MESSAGE_TEXT = 'SET_NEW_MESSAGE_TEXT';
export const DROP_MESSAGES = 'DROP_MESSAGES';

export const PRELOAD_DOCUMENT_REQUEST = 'PRELOAD_DOCUMENT_REQUEST';
export const PRELOAD_DOCUMENT_SUCCESS = 'PRELOAD_DOCUMENT_SUCCESS';
export const PRELOAD_DOCUMENT_FAILURE = 'PRELOAD_DOCUMENT_FAILURE';
export const CHECK_DOCUMENT_NEW_THREAD_REQUEST =
  'CHECK_DOCUMENT_NEW_THREAD_REQUEST';
export const CHECK_DOCUMENT_NEW_THREAD_SUCCESS =
  'CHECK_DOCUMENT_NEW_THREAD_SUCCESS';
export const CHECK_DOCUMENT_NEW_THREAD_FAILURE =
  'CHECK_DOCUMENT_NEW_THREAD_FAILURE';
export const CHECK_DOCUMENT_EXISTING_THREAD_REQUEST =
  'CHECK_DOCUMENT_EXISTING_THREAD_REQUEST';
export const CHECK_DOCUMENT_EXISTING_THREAD_SUCCESS =
  'CHECK_DOCUMENT_EXISTING_THREAD_SUCCESS';
export const CHECK_DOCUMENT_EXISTING_THREAD_FAILURE =
  'CHECK_DOCUMENT_EXISTING_THREAD_FAILURE';

export const GET_ROLES_REQUESTED = 'GET_ROLES_REQUESTED';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_FAILURE = 'GET_ROLES_FAILURE';
export const CLEAR_CHATS_REQUESTED = 'CLEAR_CHATS_REQUESTED';

export const REQUEST_DASHBOARD = 'REQUEST_DASHBOARD';
export const TOGGLE_CU_NOTIFICATIONS = 'TOGGLE_CU_NOTIFICATIONS';
export const CLEAR_CU_NOTIFICATIONS = 'CLEAR_CU_NOTIFICATIONS';

export const MARK_AS_VIEWED_BY_SCOPES_REQUEST =
  'MARK_AS_VIEWED_BY_SCOPES_REQUEST';
export const MARK_AS_VIEWED_BY_SCOPES_SUCCESS =
  'MARK_AS_VIEWED_BY_SCOPES_SUCCESS';
export const MARK_AS_VIEWED_BY_SCOPES_FAILURE =
  'MARK_AS_VIEWED_BY_SCOPES_FAILURE';

export const MARK_AS_VIEWED_BY_IDS_REQUEST = 'MARK_AS_VIEWED_BY_IDS_REQUEST';
export const MARK_AS_VIEWED_BY_IDS_SUCCESS = 'MARK_AS_VIEWED_BY_IDS_SUCCESS';
export const MARK_AS_VIEWED_BY_IDS_FAILURE = 'MARK_AS_VIEWED_BY_IDS_FAILURE';

export const GET_CU_NOTIFICATIONS_REQUEST = 'GET_CU_NOTIFICATIONS_REQUEST';
export const GET_CU_NOTIFICATIONS_SUCCESS = 'GET_CU_NOTIFICATIONS_SUCCESS';
export const GET_CU_NOTIFICATIONS_FAILURE = 'GET_CU_NOTIFICATIONS_FAILURE';

export const GET_NOTIFICATION_PREFERENCES_REQUESTED =
  'GET_NOTIFICATION_PREFERENCES_REQUESTED';
export const GET_NOTIFICATION_PREFERENCES_SUCCESS =
  'GET_NOTIFICATION_PREFERENCES_SUCCESS';
export const GET_NOTIFICATION_PREFERENCES_FAILURE =
  'GET_NOTIFICATION_PREFERENCES_FAILURE';
export const PUT_NOTIFICATION_PREFERENCES_REQUESTED =
  'PUT_NOTIFICATION_PREFERENCES_REQUESTED';
export const PUT_NOTIFICATION_PREFERENCES_SUCCESS =
  'PUT_NOTIFICATION_PREFERENCES_SUCCESS';
export const PUT_NOTIFICATION_PREFERENCES_FAILURE =
  'PUT_NOTIFICATION_PREFERENCES_FAILURE';

export const VISITOR_KEYS_BUILDINGS_REQUESTED =
  'VISITOR_KEYS_BUILDINGS_REQUESTED';
export const VISITOR_KEYS_BUILDINGS_SUCCESS = 'VISITOR_KEYS_BUILDINGS_SUCCESS';
export const VISITOR_KEYS_BUILDINGS_FAILURE = 'VISITOR_KEYS_BUILDINGS_FAILURE';
export const VISITOR_KEYS_DATA_REQUESTED = 'VISITOR_KEYS_DATA_REQUESTED';
export const VISITOR_KEYS_DATA_SUCCESS = 'VISITOR_KEYS_DATA_SUCCESS';
export const VISITOR_KEYS_DATA_FAILURE = 'VISITOR_KEYS_DATA_FAILURE';
export const UPDATE_VISITOR_KEYS_DATA_REQUESTED =
  'UPDATE_VISITOR_KEYS_DATA_REQUESTED';
export const UPDATE_VISITOR_KEYS_DATA_SUCCESS =
  'UPDATE_VISITOR_KEYS_DATA_SUCCESS';
export const UPDATE_VISITOR_KEYS_DATA_FAILURE =
  'UPDATE_VISITOR_KEYS_DATA_FAILURE';

export const GET_DIRECTORIES_REQUESTED = 'GET_DIRECTORIES_REQUESTED';
export const GET_DIRECTORIES_SUCCESS = 'GET_DIRECTORIES_SUCCESS';
export const GET_DIRECTORIES_FAILURE = 'GET_DIRECTORIES_FAILURE';
export const GET_DIRECTORIES_BY_ID_REQUESTED =
  'GET_DIRECTORIES_BY_ID_REQUESTED';
export const GET_DIRECTORIES_BY_ID_SUCCESS = 'GET_DIRECTORIES_BY_ID_SUCCESS';
export const GET_DIRECTORIES_BY_ID_FAILURE = 'GET_DIRECTORIES_BY_ID_FAILURE';
export const GET_DIRECTORY_DATA_BY_ID_REQUESTED =
  'GET_DIRECTORY_DATA_BY_ID_REQUESTED';
export const GET_DIRECTORY_DATA_BY_ID_SUCCESS =
  'GET_DIRECTORY_DATA_BY_ID_SUCCESS';
export const GET_DIRECTORY_DATA_BY_ID_FAILURE =
  'GET_DIRECTORY_DATA_BY_ID_FAILURE';
export const GET_DIRECTORY_DATA_FOR_EDIT_REQUESTED =
  'GET_DIRECTORY_DATA_FOR_EDIT_REQUESTED';
export const GET_DIRECTORY_DATA_FOR_EDIT_SUCCESS =
  'GET_DIRECTORY_DATA_FOR_EDIT_SUCCESS';
export const GET_DIRECTORY_DATA_FOR_EDIT_FAILURE =
  'GET_DIRECTORY_DATA_FOR_EDIT_FAILURE';
export const CLEAR_DIRECTORY_DATA = 'CLEAR_DIRECTORY_DATA';
export const CLEAR_ALL_DIRECTORY_DATA = 'CLEAR_ALL_DIRECTORY_DATA';
export const CREATE_DIRECTORY_REQUESTED = 'CREATE_DIRECTORY_REQUESTED';
export const CREATE_DIRECTORY_SUCCESS = 'CREATE_DIRECTORY_SUCCESS';
export const CREATE_DIRECTORY_FAILURE = 'CREATE_DIRECTORY_FAILURE';
export const UPDATE_DIRECTORY_REQUESTED = 'UPDATE_DIRECTORY_REQUESTED';
export const UPDATE_DIRECTORY_SUCCESS = 'UPDATE_DIRECTORY_SUCCESS';
export const UPDATE_DIRECTORY_FAILURE = 'UPDATE_DIRECTORY_FAILURE';
export const UPLOAD_FILE_REQUESTED = 'UPLOAD_FILE_REQUESTED';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE';
export const SEARCH_DIRECTORY_REQUESTED = 'SEARCH_DIRECTORY_REQUESTED';
export const SEARCH_DIRECTORY_SUCCESS = 'SEARCH_DIRECTORY_SUCCESS';
export const SEARCH_DIRECTORY_FAILURE = 'SEARCH_DIRECTORY_FAILURE';
export const DELETE_DIRECTORY_REQUESTED = 'DELETE_DIRECTORY_REQUESTED';
export const DELETE_DIRECTORY_SUCCESS = 'DELETE_DIRECTORY_SUCCESS';
export const DELETE_DIRECTORY_FAILURE = 'DELETE_DIRECTORY_FAILURE';
export const DELETE_FILE_REQUESTED = 'DELETE_FILE_REQUESTED';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAILURE = 'DELETE_FILE_FAILURE';
export const GET_ADMIN_ROOT_DIRECTORIES_REQUESTED =
  'GET_ADMIN_ROOT_DIRECTORIES_REQUESTED';
export const GET_ADMIN_ROOT_DIRECTORIES_SUCCESS =
  'GET_ADMIN_ROOT_DIRECTORIES_SUCCESS';
export const GET_ADMIN_ROOT_DIRECTORIES_FAILURE =
  'GET_ADMIN_ROOT_DIRECTORIES_FAILURE';
export const GET_NUMBER_OF_CHILDREN_REQUESTED =
  'GET_NUMBER_OF_CHILDREN_REQUESTED';
export const GET_NUMBER_OF_CHILDREN_SUCCESS = 'GET_NUMBER_OF_CHILDREN_SUCCESS';
export const GET_NUMBER_OF_CHILDREN_FAILURE = 'GET_NUMBER_OF_CHILDREN_FAILURE';
export const CHECK_DOCUMENT_REQUESTED = 'CHECK_DOCUMENT_REQUESTED';
export const CHECK_DOCUMENT_SUCCESS = 'CHECK_DOCUMENT_SUCCESS';
export const CHECK_DOCUMENT_FAILURE = 'CHECK_DOCUMENT_FAILURE';

export const GET_DOCUMENT_REQUEST = 'GET_DOCUMENT_REQUEST';
export const GET_DOCUMENT_SUCCESS = 'GET_DOCUMENT_SUCCESS';
export const GET_DOCUMENT_FAILURE = 'GET_DOCUMENT_FAILURE';

export const VALIDATE_ADDRESS_REQUEST = 'VALIDATE_ADDRESS_REQUEST';
export const VALIDATE_ADDRESS_SUCCESS = 'VALIDATE_ADDRESS_SUCCESS';
export const VALIDATE_ADDRESS_FAILURE = 'VALIDATE_ADDRESS_FAILURE';

export const GET_ACTIONS_LOG_REQUEST = 'GET_ACTIONS_LOG_REQUEST';
export const GET_ACTIONS_LOG_SUCCESS = 'GET_ACTIONS_LOG_SUCCESS';
export const GET_ACTIONS_LOG_FAILURE = 'GET_ACTIONS_LOG_FAILURE';

export const GET_ACTIONS_LOG_NAMES_REQUEST = 'GET_ACTIONS_LOG_NAMES_REQUEST';
export const GET_ACTIONS_LOG_NAMES_SUCCESS = 'GET_ACTIONS_LOG_NAMES_SUCCESS';
export const GET_ACTIONS_LOG_NAMES_FAILURE = 'GET_ACTIONS_LOG_NAMES_FAILURE';

export const GET_PERSON_ACTIONS_LOG_REQUEST = 'GET_PERSON_ACTIONS_LOG_REQUEST';
export const GET_PERSON_ACTIONS_LOG_SUCCESS = 'GET_PERSON_ACTIONS_LOG_SUCCESS';
export const GET_PERSON_ACTIONS_LOG_FAILURE = 'GET_PERSON_ACTIONS_LOG_FAILURE';

export const CLEAR_PERSON_ACTIONS_LOG = 'CLEAR_PERSON_ACTIONS_LOG';

export const GET_EXTERNAL_ACCOUNT_REQUEST = 'GET_EXTERNAL_ACCOUNT_REQUEST';
export const GET_EXTERNAL_ACCOUNT_SUCCESS = 'GET_EXTERNAL_ACCOUNT_SUCCESS';
export const GET_EXTERNAL_ACCOUNT_FAILURE = 'GET_EXTERNAL_ACCOUNT_FAILURE';
export const CREATE_EXTERNAL_ACCOUNT_REQUEST =
  'CREATE_EXTERNAL_ACCOUNT_REQUEST';
export const CREATE_EXTERNAL_ACCOUNT_SUCCESS =
  'CREATE_EXTERNAL_ACCOUNT_SUCCESS';
export const CREATE_EXTERNAL_ACCOUNT_FAILURE =
  'CREATE_EXTERNAL_ACCOUNT_FAILURE';
export const UPDATE_EXTERNAL_ACCOUNT_REQUEST =
  'UPDATE_EXTERNAL_ACCOUNT_REQUEST';
export const UPDATE_EXTERNAL_ACCOUNT_SUCCESS =
  'UPDATE_EXTERNAL_ACCOUNT_SUCCESS';
export const UPDATE_EXTERNAL_ACCOUNT_FAILURE =
  'UPDATE_EXTERNAL_ACCOUNT_FAILURE';
export const DELETE_EXTERNAL_ACCOUNT_REQUEST =
  'DELETE_EXTERNAL_ACCOUNT_REQUEST';
export const DELETE_EXTERNAL_ACCOUNT_SUCCESS =
  'DELETE_EXTERNAL_ACCOUNT_SUCCESS';
export const DELETE_EXTERNAL_ACCOUNT_FAILURE =
  'DELETE_EXTERNAL_ACCOUNT_FAILURE';
export const CLEAR_EXTERNAL_ACCOUNT = 'CLEAR_EXTERNAL_ACCOUNT';

export const SET_BUILDING_EXTERNAL_ACCOUNT = 'SET_BUILDING_EXTERNAL_ACCOUNT';
export const CLEAR_BUILDING_EXTERNAL_ACCOUNT =
  'CLEAR_BUILDING_EXTERNAL_ACCOUNT';

// paymentsAccounts
export const GET_LIST_OF_EXTERNAL_PAYMENTS_ACCOUNTS_REQUEST =
  'GET_LIST_OF_EXTERNAL_PAYMENTS_ACCOUNTS_REQUEST';
export const GET_LIST_OF_EXTERNAL_PAYMENTS_ACCOUNTS_SUCCESS =
  'GET_LIST_OF_EXTERNAL_PAYMENTS_ACCOUNTS_SUCCESS';
export const GET_LIST_OF_EXTERNAL_PAYMENTS_ACCOUNTS_FAILURE =
  'GET_LIST_OF_EXTERNAL_PAYMENTS_ACCOUNTS_FAILURE';
export const GET_LIST_OF_APTEXX_ACCOUNTS_REQUEST =
  'GET_LIST_OF_APTEXX_ACCOUNTS_REQUEST';
export const GET_LIST_OF_APTEXX_ACCOUNTS_SUCCESS =
  'GET_LIST_OF_APTEXX_ACCOUNTS_SUCCESS';
export const GET_LIST_OF_APTEXX_ACCOUNTS_FAILURE =
  'GET_LIST_OF_APTEXX_ACCOUNTS_FAILURE';

export const GET_LIST_OF_CLICKPAY_ACCOUNTS_REQUEST =
  'GET_LIST_OF_CLICKPAY_ACCOUNTS_REQUEST';
export const GET_LIST_OF_CLICKPAY_ACCOUNTS_SUCCESS =
  'GET_LIST_OF_CLICKPAY_ACCOUNTS_SUCCESS';
export const GET_LIST_OF_CLICKPAY_ACCOUNTS_FAILURE =
  'GET_LIST_OF_CLICKPAY_ACCOUNTS_FAILURE';

export const GET_ALL_BUILDING_PAYMENTS_ACCOUNTS_REQUEST =
  'GET_ALL_BUILDING_PAYMENTS_ACCOUNTS_REQUEST';
export const GET_ALL_BUILDING_PAYMENTS_ACCOUNTS_SUCCESS =
  'GET_ALL_BUILDING_PAYMENTS_ACCOUNTS_SUCCESS';
export const GET_ALL_BUILDING_PAYMENTS_ACCOUNTS_FAILURE =
  'GET_ALL_BUILDING_PAYMENTS_ACCOUNTS_FAILURE';

export const GET_BUILDING_PAYMENTS_ACCOUNT_REQUEST =
  'GET_BUILDING_PAYMENTS_ACCOUNT_REQUEST';
export const GET_BUILDING_PAYMENTS_ACCOUNT_SUCCESS =
  'GET_BUILDING_PAYMENTS_ACCOUNT_SUCCESS';
export const GET_BUILDING_PAYMENTS_ACCOUNT_FAILURE =
  'GET_BUILDING_PAYMENTS_ACCOUNT_FAILURE';

export const ASSIGN_PAYMENTS_ACCOUNT_TO_BUILDING_REQUEST =
  'ASSIGN_PAYMENTS_ACCOUNT_TO_BUILDING_REQUEST';
export const ASSIGN_PAYMENTS_ACCOUNT_TO_BUILDING_SUCCESS =
  'ASSIGN_PAYMENTS_ACCOUNT_TO_BUILDING_SUCCESS';
export const ASSIGN_PAYMENTS_ACCOUNT_TO_BUILDING_FAILURE =
  'ASSIGN_PAYMENTS_ACCOUNT_TO_BUILDING_FAILURE';

// accessControlAccounts
export const GET_ACC_LIST_REQUEST = 'GET_ACC_LIST_REQUEST';
export const GET_ACC_LIST_SUCCESS = 'GET_ACC_LIST_SUCCESS';
export const GET_ACC_LIST_FAILURE = 'GET_ACC_LIST_FAILURE';

export const GET_ALL_BUILDING_AC_ACCOUNTS_REQUEST =
  'GET_ALL_BUILDING_AC_ACCOUNTS_REQUEST';
export const GET_ALL_BUILDING_AC_ACCOUNTS_SUCCESS =
  'GET_ALL_BUILDING_AC_ACCOUNTS_SUCCESS';
export const GET_ALL_BUILDING_AC_ACCOUNTS_FAILURE =
  'GET_ALL_BUILDING_AC_ACCOUNTS_FAILURE';

export const GET_BUILDING_BRIVO_ACCOUNT_REQUEST =
  'GET_BUILDING_BRIVO_ACCOUNT_REQUEST';
export const GET_BUILDING_BRIVO_ACCOUNT_SUCCESS =
  'GET_BUILDING_BRIVO_ACCOUNT_SUCCESS';
export const GET_BUILDING_BRIVO_ACCOUNT_FAILURE =
  'GET_BUILDING_BRIVO_ACCOUNT_FAILURE';

export const GET_BRIVO_CLEANUP_USERS_REQUEST =
  'GET_BRIVO_CLEANUP_USERS_REQUEST';
export const GET_BRIVO_CLEANUP_USERS_SUCCESS =
  'GET_BRIVO_CLEANUP_USERS_SUCCESS';
export const GET_BRIVO_CLEANUP_USERS_FAILURE =
  'GET_BRIVO_CLEANUP_USERS_FAILURE';
export const CLEAR_BRIVO_USERS_REQUEST = 'CLEAR_BRIVO_USERS_REQUEST';
export const CLEAR_BRIVO_USERS_SUCCESS = 'CLEAR_BRIVO_USERS_SUCCESS';
export const CLEAR_BRIVO_USERS_FAILURE = 'CLEAR_BRIVO_USERS_FAILURE';

export const GET_BUILDING_SMARTAIR_ACCOUNT_REQUEST =
  'GET_BUILDING_SMARTAIR_ACCOUNT_REQUEST';
export const GET_BUILDING_SMARTAIR_ACCOUNT_SUCCESS =
  'GET_BUILDING_SMARTAIR_ACCOUNT_SUCCESS';
export const GET_BUILDING_SMARTAIR_ACCOUNT_FAILURE =
  'GET_BUILDING_SMARTAIR_ACCOUNT_FAILURE';

export const GET_BUILDING_COMELIT_ACCOUNT_REQUEST =
  'GET_BUILDING_COMELIT_ACCOUNT_REQUEST';
export const GET_BUILDING_COMELIT_ACCOUNT_SUCCESS =
  'GET_BUILDING_COMELIT_ACCOUNT_SUCCESS';
export const GET_BUILDING_COMELIT_ACCOUNT_FAILURE =
  'GET_BUILDING_COMELIT_ACCOUNT_FAILURE';

export const GET_BUILDING_2N_ACCOUNT_REQUEST =
  'GET_BUILDING_2N_ACCOUNT_REQUEST';
export const GET_BUILDING_2N_ACCOUNT_SUCCESS =
  'GET_BUILDING_2N_ACCOUNT_SUCCESS';
export const GET_BUILDING_2N_ACCOUNT_FAILURE =
  'GET_BUILDING_2N_ACCOUNT_FAILURE';
export const GET_BUILDING_AKUVOX_ACCOUNT_REQUEST =
  'GET_BUILDING_AKUVOX_ACCOUNT_REQUEST';
export const GET_BUILDING_AKUVOX_ACCOUNT_SUCCESS =
  'GET_BUILDING_AKUVOX_ACCOUNT_SUCCESS';
export const GET_BUILDING_AKUVOX_ACCOUNT_FAILURE =
  'GET_BUILDING_AKUVOX_ACCOUNT_FAILURE';

export const GET_BUILDING_BMX_ACCOUNT_REQUEST =
  'GET_BUILDING_BMX_ACCOUNT_REQUEST';
export const GET_BUILDING_BMX_ACCOUNT_SUCCESS =
  'GET_BUILDING_BMX_ACCOUNT_SUCCESS';
export const GET_BUILDING_BMX_ACCOUNT_FAILURE =
  'GET_BUILDING_BMX_ACCOUNT_FAILURE';

export const GET_BUILDING_DORMAKABA_ACCOUNT_REQUEST =
  'GET_BUILDING_DORMAKABA_ACCOUNT_REQUEST';
export const GET_BUILDING_DORMAKABA_ACCOUNT_SUCCESS =
  'GET_BUILDING_DORMAKABA_ACCOUNT_SUCCESS';
export const GET_BUILDING_DORMAKABA_ACCOUNT_FAILURE =
  'GET_BUILDING_DORMAKABA_ACCOUNT_FAILURE';

export const GET_BUILDING_LYAZON_ACCOUNT_REQUEST =
  'GET_BUILDING_LYAZON_ACCOUNT_REQUEST';
export const GET_BUILDING_LYAZON_ACCOUNT_SUCCESS =
  'GET_BUILDING_LYAZON_ACCOUNT_SUCCESS';
export const GET_BUILDING_LYAZON_ACCOUNT_FAILURE =
  'GET_BUILDING_LYAZON_ACCOUNT_FAILURE';

export const GET_BUILDING_ZERV_ACCOUNT_REQUEST =
  'GET_BUILDING_ZERV_ACCOUNT_REQUEST';
export const GET_BUILDING_ZERV_ACCOUNT_SUCCESS =
  'GET_BUILDING_ZERV_ACCOUNT_SUCCESS';
export const GET_BUILDING_ZERV_ACCOUNT_FAILURE =
  'GET_BUILDING_ZERV_ACCOUNT_FAILURE';

export const GET_BUILDING_SALTO_ACCOUNT_REQUEST =
  'GET_BUILDING_SALTO_ACCOUNT_REQUEST';
export const GET_BUILDING_SALTO_ACCOUNT_SUCCESS =
  'GET_BUILDING_SALTO_ACCOUNT_SUCCESS';
export const GET_BUILDING_SALTO_ACCOUNT_FAILURE =
  'GET_BUILDING_SALTO_ACCOUNT_FAILURE';

export const GET_BUILDING_BRIVO_SITE_ID_REQUEST =
  'GET_BUILDING_BRIVO_SITE_ID_REQUEST';
export const GET_BUILDING_BRIVO_SITE_ID_SUCCESS =
  'GET_BUILDING_BRIVO_SITE_ID_SUCCESS';
export const GET_BUILDING_BRIVO_SITE_ID_FAILURE =
  'GET_BUILDING_BRIVO_SITE_ID_FAILURE';

export const ASSOCIATE_BRIVO_WITH_BUILDING_REQUEST =
  'ASSOCIATE_BRIVO_WITH_BUILDING_REQUEST';
export const ASSOCIATE_BRIVO_WITH_BUILDING_SUCCESS =
  'ASSOCIATE_BRIVO_WITH_BUILDING_SUCCESS';
export const ASSOCIATE_BRIVO_WITH_BUILDING_FAILURE =
  'ASSOCIATE_BRIVO_WITH_BUILDING_FAILURE';

export const ASSOCIATE_SMARTAIR_WITH_BUILDING_REQUEST =
  'ASSOCIATE_SMARTAIR_WITH_BUILDING_REQUEST';
export const ASSOCIATE_SMARTAIR_WITH_BUILDING_SUCCESS =
  'ASSOCIATE_SMARTAIR_WITH_BUILDING_SUCCESS';
export const ASSOCIATE_SMARTAIR_WITH_BUILDING_FAILURE =
  'ASSOCIATE_SMARTAIR_WITH_BUILDING_FAILURE';

export const ASSOCIATE_COMELIT_WITH_BUILDING_REQUEST =
  'ASSOCIATE_COMELIT_WITH_BUILDING_REQUEST';
export const ASSOCIATE_COMELIT_WITH_BUILDING_SUCCESS =
  'ASSOCIATE_COMELIT_WITH_BUILDING_SUCCESS';
export const ASSOCIATE_COMELIT_WITH_BUILDING_FAILURE =
  'ASSOCIATE_COMELIT_WITH_BUILDING_FAILURE';

export const ASSOCIATE_2N_WITH_BUILDING_REQUEST =
  'ASSOCIATE_2N_WITH_BUILDING_REQUEST';
export const ASSOCIATE_2N_WITH_BUILDING_SUCCESS =
  'ASSOCIATE_2N_WITH_BUILDING_SUCCESS';
export const ASSOCIATE_2N_WITH_BUILDING_FAILURE =
  'ASSOCIATE_2N_WITH_BUILDING_FAILURE';

// TODO: use these for all accounts
export const ASSOCIATE_ACCOUNT_WITH_BUILDING_REQUEST =
  'ASSOCIATE_ACCOUNT_WITH_BUILDING_REQUEST';
export const ASSOCIATE_ACCOUNT_WITH_BUILDING_SUCCESS =
  'ASSOCIATE_ACCOUNT_WITH_BUILDING_SUCCESS';
export const ASSOCIATE_ACCOUNT_WITH_BUILDING_FAILURE =
  'ASSOCIATE_ACCOUNT_WITH_BUILDING_FAILURE';

export const ASSOCIATE_BMX_WITH_BUILDING_REQUEST =
  'ASSOCIATE_BMX_WITH_BUILDING_REQUEST';
export const ASSOCIATE_BMX_WITH_BUILDING_SUCCESS =
  'ASSOCIATE_BMX_WITH_BUILDING_SUCCESS';
export const ASSOCIATE_BMX_WITH_BUILDING_FAILURE =
  'ASSOCIATE_BMX_WITH_BUILDING_FAILURE';

export const ASSOCIATE_DORMAKABA_WITH_BUILDING_REQUEST =
  'ASSOCIATE_DORMAKABA_WITH_BUILDING_REQUEST';
export const ASSOCIATE_DORMAKABA_WITH_BUILDING_SUCCESS =
  'ASSOCIATE_DORMAKABA_WITH_BUILDING_SUCCESS';
export const ASSOCIATE_DORMAKABA_WITH_BUILDING_FAILURE =
  'ASSOCIATE_DORMAKABA_WITH_BUILDING_FAILURE';

export const ASSOCIATE_LYAZON_WITH_BUILDING_REQUEST =
  'ASSOCIATE_LYAZON_WITH_BUILDING_REQUEST';
export const ASSOCIATE_LYAZON_WITH_BUILDING_SUCCESS =
  'ASSOCIATE_LYAZON_WITH_BUILDING_SUCCESS';
export const ASSOCIATE_LYAZON_WITH_BUILDING_FAILURE =
  'ASSOCIATE_LYAZON_WITH_BUILDING_FAILURE';

export const ASSOCIATE_ZERV_WITH_BUILDING_REQUEST =
  'ASSOCIATE_ZERV_WITH_BUILDING_REQUEST';
export const ASSOCIATE_ZERV_WITH_BUILDING_SUCCESS =
  'ASSOCIATE_ZERV_WITH_BUILDING_SUCCESS';
export const ASSOCIATE_ZERV_WITH_BUILDING_FAILURE =
  'ASSOCIATE_ZERV_WITH_BUILDING_FAILURE';

export const ASSOCIATE_SALTO_WITH_BUILDING_REQUEST =
  'ASSOCIATE_SALTO_WITH_BUILDING_REQUEST';
export const ASSOCIATE_SALTO_WITH_BUILDING_SUCCESS =
  'ASSOCIATE_SALTO_WITH_BUILDING_SUCCESS';
export const ASSOCIATE_SALTO_WITH_BUILDING_FAILURE =
  'ASSOCIATE_SALTO_WITH_BUILDING_FAILURE';

export const REMOVE_AC_ACCOUNT_REQUEST = 'REMOVE_AC_ACCOUNT_REQUEST';
export const REMOVE_AC_ACCOUNT_SUCCESS = 'REMOVE_AC_ACCOUNT_SUCCESS';
export const REMOVE_AC_ACCOUNT_FAILURE = 'REMOVE_AC_ACCOUNT_FAILURE';

export const GET_BUILDING_KEYSCAN_ACCOUNT_REQUEST =
  'GET_BUILDING_KEYSCAN_ACCOUNT_REQUEST';
export const GET_BUILDING_KEYSCAN_ACCOUNT_SUCCESS =
  'GET_BUILDING_KEYSCAN_ACCOUNT_SUCCESS';
export const GET_BUILDING_KEYSCAN_ACCOUNT_FAILURE =
  'GET_BUILDING_KEYSCAN_ACCOUNT_FAILURE';
export const ASSOCIATE_KEYSCAN_WITH_BUILDING_REQUEST =
  'ASSOCIATE_KEYSCAN_WITH_BUILDING_REQUEST';
export const ASSOCIATE_KEYSCAN_WITH_BUILDING_SUCCESS =
  'ASSOCIATE_KEYSCAN_WITH_BUILDING_SUCCESS';
export const ASSOCIATE_KEYSCAN_WITH_BUILDING_FAILURE =
  'ASSOCIATE_KEYSCAN_WITH_BUILDING_FAILURE';

// camerasAccounts
export const GET_LIST_OF_EE_ACCOUNTS_REQUEST =
  'GET_LIST_OF_EE_ACCOUNTS_REQUEST';
export const GET_LIST_OF_EE_ACCOUNTS_SUCCESS =
  'GET_LIST_OF_EE_ACCOUNTS_SUCCESS';
export const GET_LIST_OF_EE_ACCOUNTS_FAILURE =
  'GET_LIST_OF_EE_ACCOUNTS_FAILURE';

export const GET_ALL_BUILDING_EE_ACCOUNTS_REQUEST =
  'GET_ALL_BUILDING_EE_ACCOUNTS_REQUEST';
export const GET_ALL_BUILDING_EE_ACCOUNTS_SUCCESS =
  'GET_ALL_BUILDING_EE_ACCOUNTS_SUCCESS';
export const GET_ALL_BUILDING_EE_ACCOUNTS_FAILURE =
  'GET_ALL_BUILDING_EE_ACCOUNTS_FAILURE';

export const GET_BUILDING_EE_ACCOUNT_REQUEST =
  'GET_BUILDING_EE_ACCOUNT_REQUEST';
export const GET_BUILDING_EE_ACCOUNT_SUCCESS =
  'GET_BUILDING_EE_ACCOUNT_SUCCESS';
export const GET_BUILDING_EE_ACCOUNT_FAILURE =
  'GET_BUILDING_EE_ACCOUNT_FAILURE';

export const ASSIGN_EE_ACCOUNT_TO_BUILDING_REQUEST =
  'ASSIGN_EE_ACCOUNT_TO_BUILDING_REQUEST';
export const ASSIGN_EE_ACCOUNT_TO_BUILDING_SUCCESS =
  'ASSIGN_EE_ACCOUNT_TO_BUILDING_SUCCESS';
export const ASSIGN_EE_ACCOUNT_TO_BUILDING_FAILURE =
  'ASSIGN_EE_ACCOUNT_TO_BUILDING_FAILURE';

// Custom Integrations
export const GET_EXTERNAL_LINKS_LIST_REQUEST =
  'GET_EXTERNAL_LINKS_LIST_REQUEST';
export const GET_EXTERNAL_LINKS_LIST_SUCCESS =
  'GET_EXTERNAL_LINKS_LIST_SUCCESS';
export const GET_EXTERNAL_LINKS_LIST_FAILURE =
  'GET_EXTERNAL_LINKS_LIST_FAILURE';
export const GET_EXTERNAL_LINK_REQUEST = 'GET_EXTERNAL_LINK_REQUEST';
export const GET_EXTERNAL_LINK_SUCCESS = 'GET_EXTERNAL_LINK_SUCCESS';
export const GET_EXTERNAL_LINK_FAILURE = 'GET_EXTERNAL_LINK_FAILURE';

export const GET_BUILDING_EXTERNAL_LINKS_REQUEST =
  'GET_BUILDING_EXTERNAL_LINKS_REQUEST';
export const GET_BUILDING_EXTERNAL_LINKS_SUCCESS =
  'GET_BUILDING_EXTERNAL_LINKS_SUCCESS';
export const GET_BUILDING_EXTERNAL_LINKS_FAILURE =
  'GET_BUILDING_EXTERNAL_LINKS_FAILURE';

export const GET_BUILDING_EXTERNAL_LINK_REQUEST =
  'GET_BUILDING_EXTERNAL_LINK_REQUEST';
export const GET_BUILDING_EXTERNAL_LINK_SUCCESS =
  'GET_BUILDING_EXTERNAL_LINK_SUCCESS';
export const GET_BUILDING_EXTERNAL_LINK_FAILURE =
  'GET_BUILDING_EXTERNAL_LINK_FAILURE';

export const MODIFY_BUILDING_EXTERNAL_LINK_REQUEST =
  'MODIFY_BUILDING_EXTERNAL_LINK_REQUEST';
export const MODIFY_BUILDING_EXTERNAL_LINK_SUCCESS =
  'MODIFY_BUILDING_EXTERNAL_LINK_SUCCESS';
export const MODIFY_BUILDING_EXTERNAL_LINK_FAILURE =
  'MODIFY_BUILDING_EXTERNAL_LINK_FAILURE';

export const MODIFY_BUILDING_EXTERNAL_LINKS_REQUEST =
  'MODIFY_BUILDING_EXTERNAL_LINKS_REQUEST';
export const MODIFY_BUILDING_EXTERNAL_LINKS_SUCCESS =
  'MODIFY_BUILDING_EXTERNAL_LINKS_SUCCESS';
export const MODIFY_BUILDING_EXTERNAL_LINKS_FAILURE =
  'MODIFY_BUILDING_EXTERNAL_LINKS_FAILURE';

export const GET_ALL_BUILDING_EXTERNAL_LINKS_REQUEST =
  'GET_ALL_BUILDING_EXTERNAL_LINKS_REQUEST';
export const GET_ALL_BUILDING_EXTERNAL_LINKS_SUCCESS =
  'GET_ALL_BUILDING_EXTERNAL_LINKS_SUCCESS';
export const GET_ALL_BUILDING_EXTERNAL_LINKS_FAILURE =
  'GET_ALL_BUILDING_EXTERNAL_LINKS_FAILURE';

// accounting
export const GET_ALL_BUILDING_ACCOUNTING_ACCOUNTS_REQUEST =
  'GET_ALL_BUILDING_ACCOUNTING_ACCOUNTS_REQUEST';
export const GET_ALL_BUILDING_ACCOUNTING_ACCOUNTS_SUCCESS =
  'GET_ALL_BUILDING_ACCOUNTING_ACCOUNTS_SUCCESS';
export const GET_ALL_BUILDING_ACCOUNTING_ACCOUNTS_FAILURE =
  'GET_ALL_BUILDING_ACCOUNTING_ACCOUNTS_FAILURE';

export const GET_BUILDING_YARDI_ACCOUNT_REQUEST =
  'GET_BUILDING_YARDI_ACCOUNT_REQUEST';
export const GET_BUILDING_YARDI_ACCOUNT_SUCCESS =
  'GET_BUILDING_YARDI_ACCOUNT_SUCCESS';
export const GET_BUILDING_YARDI_ACCOUNT_FAILURE =
  'GET_BUILDING_YARDI_ACCOUNT_FAILURE';

export const GET_BUILDING_MRI_ACCOUNT_REQUEST =
  'GET_BUILDING_MRI_ACCOUNT_REQUEST';
export const GET_BUILDING_MRI_ACCOUNT_SUCCESS =
  'GET_BUILDING_MRI_ACCOUNT_SUCCESS';
export const GET_BUILDING_MRI_ACCOUNT_FAILURE =
  'GET_BUILDING_MRI_ACCOUNT_FAILURE';

export const GET_BUILDING_APPFOLIO_ACCOUNT_REQUEST =
  'GET_BUILDING_APPFOLIO_ACCOUNT_REQUEST';
export const GET_BUILDING_APPFOLIO_ACCOUNT_SUCCESS =
  'GET_BUILDING_APPFOLIO_ACCOUNT_SUCCESS';
export const GET_BUILDING_APPFOLIO_ACCOUNT_FAILURE =
  'GET_BUILDING_APPFOLIO_ACCOUNT_FAILURE';

export const GET_BUILDING_MDS_ACCOUNT_REQUEST =
  'GET_BUILDING_MDS_ACCOUNT_REQUEST';
export const GET_BUILDING_MDS_ACCOUNT_SUCCESS =
  'GET_BUILDING_MDS_ACCOUNT_SUCCESS';
export const GET_BUILDING_MDS_ACCOUNT_FAILURE =
  'GET_BUILDING_MDS_ACCOUNT_FAILURE';

export const ASSIGN_YARDI_ACCOUNT_TO_BUILDING_REQUEST =
  'ASSIGN_YARDI_ACCOUNT_TO_BUILDING_REQUEST';
export const ASSIGN_YARDI_ACCOUNT_TO_BUILDING_SUCCESS =
  'ASSIGN_YARDI_ACCOUNT_TO_BUILDING_SUCCESS';
export const ASSIGN_YARDI_ACCOUNT_TO_BUILDING_FAILURE =
  'ASSIGN_YARDI_ACCOUNT_TO_BUILDING_FAILURE';

export const ASSIGN_MRI_ACCOUNT_TO_BUILDING_REQUEST =
  'ASSIGN_MRI_ACCOUNT_TO_BUILDING_REQUEST';
export const ASSIGN_MRI_ACCOUNT_TO_BUILDING_SUCCESS =
  'ASSIGN_MRI_ACCOUNT_TO_BUILDING_SUCCESS';
export const ASSIGN_MRI_ACCOUNT_TO_BUILDING_FAILURE =
  'ASSIGN_MRI_ACCOUNT_TO_BUILDING_FAILURE';

export const ASSIGN_APPFOLIO_ACCOUNT_TO_BUILDING_REQUEST =
  'ASSIGN_APPFOLIO_ACCOUNT_TO_BUILDING_REQUEST';
export const ASSIGN_APPFOLIO_ACCOUNT_TO_BUILDING_SUCCESS =
  'ASSIGN_APPFOLIO_ACCOUNT_TO_BUILDING_SUCCESS';
export const ASSIGN_APPFOLIO_ACCOUNT_TO_BUILDING_FAILURE =
  'ASSIGN_APPFOLIO_ACCOUNT_TO_BUILDING_FAILURE';

export const ASSIGN_MDS_ACCOUNT_TO_BUILDING_REQUEST =
  'ASSIGN_MDS_ACCOUNT_TO_BUILDING_REQUEST';
export const ASSIGN_MDS_ACCOUNT_TO_BUILDING_SUCCESS =
  'ASSIGN_MDS_ACCOUNT_TO_BUILDING_SUCCESS';
export const ASSIGN_MDS_ACCOUNT_TO_BUILDING_FAILURE =
  'ASSIGN_MDS_ACCOUNT_TO_BUILDING_FAILURE';

export const UPDATE_ACCOUNTING_ACCOUNT_REQUEST =
  'UPDATE_ACCOUNTING_ACCOUNT_REQUEST';
export const UPDATE_ACCOUNTING_ACCOUNT_SUCCESS =
  'UPDATE_ACCOUNTING_ACCOUNT_SUCCESS';
export const UPDATE_ACCOUNTING_ACCOUNT_FAILURE =
  'UPDATE_ACCOUNTING_ACCOUNT_FAILURE';
export const REMOVE_ACCOUNTING_ACCOUNT_REQUEST =
  'REMOVE_ACCOUNTING_ACCOUNT_REQUEST';
export const REMOVE_ACCOUNTING_ACCOUNT_SUCCESS =
  'REMOVE_ACCOUNTING_ACCOUNT_SUCCESS';
export const REMOVE_ACCOUNTING_ACCOUNT_FAILURE =
  'REMOVE_ACCOUNTING_ACCOUNT_FAILURE';

export const GET_REGISTERED_PERSONS_COUNT_REQUEST =
  'GET_REGISTERED_PERSONS_COUNT_REQUEST';
export const GET_REGISTERED_PERSONS_COUNT_SUCCESS =
  'GET_REGISTERED_PERSONS_COUNT_SUCCESS';
export const GET_REGISTERED_PERSONS_COUNT_FAILURE =
  'GET_REGISTERED_PERSONS_COUNT_FAILURE';
export const GET_REGISTERED_ALL_COUNT_REQUEST =
  'GET_REGISTERED_ALL_COUNT_REQUEST';
export const GET_REGISTERED_ALL_COUNT_SUCCESS =
  'GET_REGISTERED_ALL_COUNT_SUCCESS';
export const GET_REGISTERED_ALL_COUNT_FAILURE =
  'GET_REGISTERED_ALL_COUNT_FAILURE';
export const CLEAR_REGISTERED_USERS_COUNT = 'CLEAR_REGISTERED_USERS_COUNT';
export const CLEAR_PERSON_BY_ID = 'CLEAR_PERSON_BY_ID';

export const SET_NEW_SELECT_VALUE = 'SET_NEW_SELECT_VALUE';
export const SET_CURRENT_CHAT_ID = 'SET_CURRENT_CHAT_ID';
export const SET_NEW_ACTIONS_COUNT = 'SET_NEW_ACTIONS_COUNT';

export const GET_BMX_ACCESS_TOKEN_REQUEST = 'GET_BMX_ACCESS_TOKEN_REQUEST';
export const GET_BMX_ACCESS_TOKEN_SUCCESS = 'GET_BMX_ACCESS_TOKEN_SUCCESS';
export const GET_BMX_ACCESS_TOKEN_FAILURE = 'GET_BMX_ACCESS_TOKEN_FAILURE';

export const SYNC_BMX_DOORS_REQUEST = 'SYNC_BMX_DOORS_REQUEST';
export const SYNC_BMX_DOORS_SUCCESS = 'SYNC_BMX_DOORS_SUCCESS';
export const SYNC_BMX_DOORS_FAILURE = 'SYNC_BMX_DOORS_FAILURE';

export const SEND_BMX_STATUS_REQUEST = 'SEND_BMX_STATUS_REQUEST';
export const SEND_BMX_STATUS_SUCCESS = 'SEND_BMX_STATUS_SUCCESS';
export const SEND_BMX_STATUS_FAILURE = 'SEND_BMX_STATUS_FAILURE';

export const DOORS_LIST_SUCCEEDED = 'DOORS_LIST_SUCCEEDED';
export const SYNC_BMX_PERSONS_FAILURE = 'SYNC_BMX_PERSONS_FAILURE';
export const SYNC_BMX_PERSONS_SUCCESS = 'SYNC_BMX_PERSONS_SUCCESS';

export const SET_TODAY_COUNT = 'SET_TODAY_COUNT';
export const SET_FREQUENCY_STATS = 'SET_FREQUENCY_STATS';

export const GET_ACCESS_CARDS_LIST_REQUEST = 'GET_ACCESS_CARDS_LIST_REQUEST';
export const GET_ACCESS_CARDS_LIST_SUCCESS = 'GET_ACCESS_CARDS_LIST_SUCCESS';
export const GET_ACCESS_CARDS_LIST_FAILURE = 'GET_ACCESS_CARDS_LIST_FAILURE';

export const CREATE_ACCESS_CARD_REQUEST = 'CREATE_ACCESS_CARD_REQUEST';
export const CREATE_ACCESS_CARD_SUCCESS = 'CREATE_ACCESS_CARD_SUCCESS';
export const CREATE_ACCESS_CARD_FAILURE = 'CREATE_ACCESS_CARD_FAILURE';

export const GET_ACCESS_CARD_REQUEST = 'GET_ACCESS_CARD_REQUEST';
export const GET_ACCESS_CARD_SUCCESS = 'GET_ACCESS_CARD_SUCCESS';
export const GET_ACCESS_CARD_FAILURE = 'GET_ACCESS_CARD_FAILURE';

export const DELETE_ACCESS_CARD_REQUEST = 'DELETE_ACCESS_CARD_REQUEST';
export const DELETE_ACCESS_CARD_SUCCESS = 'DELETE_ACCESS_CARD_SUCCESS';
export const DELETE_ACCESS_CARD_FAILURE = 'DELETE_ACCESS_CARD_FAILURE';

export const UPDATE_ACCESS_CARD_REQUEST = 'UPDATE_ACCESS_CARD_REQUEST';
export const UPDATE_ACCESS_CARD_SUCCESS = 'UPDATE_ACCESS_CARD_SUCCESS';
export const UPDATE_ACCESS_CARD_FAILURE = 'UPDATE_ACCESS_CARD_FAILURE';

export const VALIDATE_ACCESS_CARD_REQUEST = 'VALIDATE_ACCESS_CARD_REQUEST';
export const VALIDATE_ACCESS_CARD_SUCCESS = 'VALIDATE_ACCESS_CARD_SUCCESS';
export const VALIDATE_ACCESS_CARD_FAILURE = 'VALIDATE_ACCESS_CARD_FAILURE';
export const GET_STATISTICS_REQUEST = 'GET_STATISTICS_REQUEST';
export const GET_STATISTICS_SUCCESS = 'GET_STATISTICS_SUCCESS';
export const GET_STATISTICS_FAILURE = 'GET_STATISTICS_FAILURE';

export const SEND_STATISTICS_REQUEST = 'SEND_STATISTICS_REQUEST';
export const SEND_STATISTICS_SUCCESS = 'SEND_STATISTICS_SUCCESS';
export const SEND_STATISTICS_FAILURE = 'SEND_STATISTICS_FAILURE';

export const LOG_EXPORT_REQUEST = 'LOG_EXPORT_REQUEST';
export const LOG_EXPORT_SUCCESS = 'LOG_EXPORT_SUCCESS';
export const LOG_EXPORT_FAILURE = 'LOG_EXPORT_FAILURE';

export const GET_ANNOUNCEMENTS_REQUEST = 'GET_ANNOUNCEMENTS_REQUEST';
export const GET_ANNOUNCEMENTS_SUCCESS = 'GET_ANNOUNCEMENTS_SUCCESS';
export const GET_ANNOUNCEMENTS_FAILURE = 'GET_ANNOUNCEMENTS_FAILURE';
export const CREATE_ANNOUNCEMENT_REQUEST = 'CREATE_ANNOUNCEMENT_REQUEST';
export const CREATE_ANNOUNCEMENT_SUCCESS = 'CREATE_ANNOUNCEMENT_SUCCESS';
export const CREATE_ANNOUNCEMENT_FAILURE = 'CREATE_ANNOUNCEMENT_FAILURE';
export const UPDATE_ANNOUNCEMENT_REQUEST = 'UPDATE_ANNOUNCEMENT_REQUEST';
export const UPDATE_ANNOUNCEMENT_SUCCESS = 'UPDATE_ANNOUNCEMENT_SUCCESS';
export const UPDATE_ANNOUNCEMENT_FAILURE = 'UPDATE_ANNOUNCEMENT_FAILURE';
export const DELETE_ANNOUNCEMENT_REQUEST = 'DELETE_ANNOUNCEMENT_REQUEST';
export const DELETE_ANNOUNCEMENT_SUCCESS = 'DELETE_ANNOUNCEMENT_SUCCESS';
export const DELETE_ANNOUNCEMENT_FAILURE = 'DELETE_ANNOUNCEMENT_FAILURE';
export const SEND_ANNOUNCEMENT_REQUEST = 'SEND_ANNOUNCEMENT_REQUEST';
export const SEND_ANNOUNCEMENT_SUCCESS = 'SEND_ANNOUNCEMENT_SUCCESS';
export const SEND_ANNOUNCEMENT_FAILURE = 'SEND_ANNOUNCEMENT_FAILURE';

export const SET_DRAWER_OPENED = 'SET_DRAWER_OPENED';

export const SET_MOBILE_MODE = 'SET_MOBILE_MODE';

export const SUBMIT_LEASING_MESSAGE_REQUEST = 'SUBMIT_LEASING_MESSAGE_REQUEST';
export const SUBMIT_LEASING_MESSAGE_SUCCESS = 'SUBMIT_LEASING_MESSAGE_SUCCESS';
export const SUBMIT_LEASING_MESSAGE_FAILURE = 'SUBMIT_LEASING_MESSAGE_FAILURE';
export const GET_AMENITY_RESERVATIONS_REQUEST =
  'GET_AMENITY_RESERVATIONS_REQUEST';
export const GET_AMENITY_RESERVATIONS_SUCCESS =
  'GET_AMENITY_RESERVATIONS_SUCCESS';
export const GET_AMENITY_RESERVATIONS_FAILURE =
  'GET_AMENITY_RESERVATIONS_FAILURE';
export const SET_AMENITY_RESERVATIONS_PLACEHOLDER =
  'SET_AMENITY_RESERVATIONS_PLACEHOLDER';
export const GET_AMENITY_RESERVATION_REQUEST =
  'GET_AMENITY_RESERVATION_REQUEST';
export const GET_AMENITY_RESERVATION_SUCCESS =
  'GET_AMENITY_RESERVATION_SUCCESS';
export const GET_AMENITY_RESERVATION_FAILURE =
  'GET_AMENITY_RESERVATION_FAILURE';
export const GET_AMENITIES_REQUEST = 'GET_AMENITIES_REQUEST';
export const GET_AMENITIES_SUCCESS = 'GET_AMENITIES_SUCCESS';
export const GET_AMENITIES_FAILURE = 'GET_AMENITIES_FAILURE';
export const GET_AMENITY_REQUEST = 'GET_AMENITY_REQUEST';
export const GET_AMENITY_SUCCESS = 'GET_AMENITY_SUCCESS';
export const GET_AMENITY_FAILURE = 'GET_AMENITY_FAILURE';
export const GET_RESERVED_DATES_REQUEST = 'GET_RESERVED_DATES_REQUEST';
export const GET_RESERVED_DATES_SUCCESS = 'GET_RESERVED_DATES_SUCCESS';
export const GET_RESERVED_DATES_FAILURE = 'GET_RESERVED_DATES_FAILURE';
export const GET_ALLOWED_HOURS_REQUEST = 'GET_ALLOWED_HOURS_REQUEST';
export const GET_ALLOWED_HOURS_SUCCESS = 'GET_ALLOWED_HOURS_SUCCESS';
export const GET_ALLOWED_HOURS_FAILURE = 'GET_ALLOWED_HOURS_FAILURE';
export const RESERVE_AMENITY_REQUEST = 'RESERVE_AMENITY_REQUEST';
export const RESERVE_AMENITY_SUCCESS = 'RESERVE_AMENITY_SUCCESS';
export const RESERVE_AMENITY_FAILURE = 'RESERVE_AMENITY_FAILURE';
export const DELETE_AMENITY_IMAGE = 'DELETE_AMENITY_IMAGE';
export const DELETE_AMENITY_IMAGE_SUCCESS = 'DELETE_AMENITY_IMAGE_SUCCESS';
export const DELETE_AMENITY_IMAGE_FAILURE = 'DELETE_AMENITY_IMAGE_FAILURE';
export const REMOVE_RESERVATION_REQUEST = 'REMOVE_RESERVATION_REQUEST';
export const REMOVE_RESERVATION_SUCCESS = 'REMOVE_RESERVATION_SUCCESS';
export const REMOVE_RESERVATION_FAILURE = 'REMOVE_RESERVATION_FAILURE';

export const CREATE_AMENITY_REQUEST = 'CREATE_AMENITY_REQUEST';
export const CREATE_AMENITY_SUCCESS = 'CREATE_AMENITY_SUCCESS';
export const CREATE_AMENITY_FAILURE = 'CREATE_AMENITY_FAILURE';
export const UPDATE_AMENITY_REQUEST = 'UPDATE_AMENITY_REQUEST';
export const UPDATE_AMENITY_SUCCESS = 'UPDATE_AMENITY_SUCCESS';
export const UPDATE_AMENITY_FAILURE = 'UPDATE_AMENITY_FAILURE';
export const REMOVE_AMENITY_REQUEST = 'REMOVE_AMENITY_REQUEST';
export const REMOVE_AMENITY_SUCCESS = 'REMOVE_AMENITY_SUCCESS';
export const REMOVE_AMENITY_FAILURE = 'REMOVE_AMENITY_FAILURE';

export const UPDATE_AMENITY_RESERVATION_REQUEST =
  'UPDATE_AMENITY_RESERVATION_REQUEST';
export const UPDATE_AMENITY_RESERVATION_SUCCESS =
  'UPDATE_AMENITY_RESERVATION_SUCCESS';
export const UPDATE_AMENITY_RESERVATION_FAILURE =
  'UPDATE_AMENITY_RESERVATION_FAILURE';

export const GET_ITEMS_FOR_EXPORT_SUCCESS = 'GET_ITEMS_FOR_EXPORT_SUCCESS';
export const CLEAR_AMENITIES = 'CLEAR_AMENITIES';

export const GET_MONTHLY_BILL_REQUEST = 'GET_MONTHLY_BILL_REQUEST';
export const GET_MONTHLY_BILL_SUCCESS = 'GET_MONTHLY_BILL_SUCCESS';
export const GET_MONTHLY_BILL_FAILURE = 'GET_MONTHLY_BILL_FAILURE';

export const GET_LEASING_INQ_REQUEST = 'GET_LEASING_INQ_REQUEST';
export const GET_LEASING_INQ_SUCCESS = 'GET_LEASING_INQ_SUCCESS';
export const GET_LEASING_INQ_FAILURE = 'GET_LEASING_INQ_FAILURE';

export const GET_CALENDAR_EVENTS = 'GET_CALENDAR_EVENTS';
export const SET_CALENDAR_EVENTS = 'SET_CALENDAR_EVENTS';

export const SET_CURRENT_CAMERA_ID = 'SET_CURRENT_CAMERA_ID';

export const TOGGLE_LOGO_DISABLED_REQUEST = 'TOGGLE_LOGO_DISABLED_REQUEST';
export const TOGGLE_LOGO_DISABLED_SUCCESS = 'TOGGLE_LOGO_DISABLED_SUCCESS';
export const TOGGLE_LOGO_DISABLED_FAILURE = 'TOGGLE_LOGO_DISABLED_FAILURE';
export const DELETE_LOGO_REQUEST = 'DELETE_LOGO_REQUEST';
export const DELETE_LOGO_SUCCESS = 'DELETE_LOGO_SUCCESS';
export const DELETE_LOGO_FAILURE = 'DELETE_LOGO_FAILURE';

export const UPDATE_ROLE_REQUEST = 'UPDATE_ROLE_REQUEST';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAILURE = 'UPDATE_ROLE_FAILURE';

export const GET_COMMUNITY_LIST_REQUEST = 'GET_COMMUNITY_LIST_REQUEST';
export const GET_COMMUNITY_LIST_SUCCESS = 'GET_COMMUNITY_LIST_SUCCESS';
export const GET_COMMUNITY_LIST_FAILURE = 'GET_COMMUNITY_LIST_FAILURE';

export const GET_COMMUNITY_MEMBERS_LIST_REQUEST =
  'GET_COMMUNITY_MEMBERS_LIST_REQUEST';
export const GET_COMMUNITY_MEMBERS_LIST_SUCCESS =
  'GET_COMMUNITY_MEMBERS_LIST_SUCCESS';
export const GET_COMMUNITY_MEMBERS_LIST_FAILURE =
  'GET_COMMUNITY_MEMBERS_LIST_FAILURE';

export const GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_FAILURE =
  'GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_FAILURE';
export const GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_REQUEST =
  'GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_REQUEST';
export const GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_SUCCESS =
  'GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_SUCCESS';

export const BAN_MEMBER_FAILURE = 'BAN_MEMBER_FAILURE';
export const BAN_MEMBER_REQUEST = 'BAN_MEMBER_REQUEST';
export const BAN_MEMBER_SUCCESS = 'BAN_MEMBER_SUCCESS';

export const GET_COMMUNITY_CHATS_REQUESTED = 'GET_COMMUNITY_CHATS_REQUESTED';
export const GET_COMMUNITY_CHATS_SUCCESS = 'GET_COMMUNITY_CHATS_SUCCESS';
export const GET_COMMUNITY_CHATS_FAILURE = 'GET_COMMUNITY_CHATS_FAILURE';

export const GET_POSTS_LIST_REQUEST = 'GET_POSTS_LIST_REQUEST';
export const GET_POSTS_LIST_SUCCESS = 'GET_POSTS_LIST_SUCCESS';
export const GET_POSTS_LIST_FAILURE = 'GET_POSTS_LIST_FAILURE';

export const CLEAR_POSTS_LIST_REQUEST = 'CLEAR_POSTS_LIST_REQUEST';
export const CLEAR_MEMBERS_LIST_REQUEST = 'CLEAR_MEMBERS_LIST_REQUEST';

export const GET_POST_BY_ID_REQUEST = 'GET_POST_BY_ID_REQUEST';
export const GET_POST_BY_ID_SUCCESS = 'GET_POST_BY_ID_SUCCESS';
export const GET_POST_BY_ID_FAILURE = 'GET_POST_BY_ID_FAILURE';

export const UPDATE_COMMUNITY_REQUEST = 'UPDATE_COMMUNITY_REQUEST';
export const UPDATE_COMMUNITY_SUCCESS = 'UPDATE_COMMUNITY_SUCCESS';
export const UPDATE_COMMUNITY_FAILURE = 'UPDATE_COMMUNITY_FAILURE';

export const COMMUNITY_OPT_IN_OUT_REQUEST = 'COMMUNITY_OPT_IN_OUT_REQUEST';
export const COMMUNITY_OPT_IN_OUT_SUCCESS = 'COMMUNITY_OPT_IN_OUT_SUCCESS';
export const COMMUNITY_OPT_IN_OUT_FAILURE = 'COMMUNITY_OPT_IN_OUT_FAILURE';

export const COMMUNITY_THREAD_EXISTS_REQUEST =
  'COMMUNITY_THREAD_EXISTS_REQUEST';
export const COMMUNITY_THREAD_EXISTS_SUCCESS =
  'COMMUNITY_THREAD_EXISTS_SUCCESS';
export const COMMUNITY_THREAD_EXISTS_FAILURE =
  'COMMUNITY_THREAD_EXISTS_FAILURE';
export const GET_COMMUNITY_CHAT_BY_ID_REQUEST =
  'GET_COMMUNITY_CHAT_BY_ID_REQUEST';
export const GET_COMMUNITY_CHAT_BY_ID_SUCCESS =
  'GET_COMMUNITY_CHAT_BY_ID_SUCCESS';
export const GET_COMMUNITY_CHAT_BY_ID_FAILURE =
  'GET_COMMUNITY_CHAT_BY_ID_FAILURE';
export const GET_COMMUNITY_CHAT_INFO_BY_ID_REQUEST =
  'GET_COMMUNITY_CHAT_INFO_BY_ID_REQUEST';
export const GET_COMMUNITY_CHAT_INFO_BY_ID_SUCCESS =
  'GET_COMMUNITY_CHAT_INFO_BY_ID_SUCCESS';
export const GET_COMMUNITY_CHAT_INFO_BY_ID_FAILURE =
  'GET_COMMUNITY_CHAT_INFO_BY_ID_FAILURE';

export const COMMUNITY_DROP_MESSAGES = 'COMMUNITY_DROP_MESSAGES';
export const COMMUNITY_SET_DOCUMENT_ATTACHMENT =
  'COMMUNITY_SET_DOCUMENT_ATTACHMENT';

export const UPDATE_COMMUNITY_ITEM_STATUS_REQUEST =
  'UPDATE_COMMUNITY_ITEM_STATUS_REQUEST';
export const UPDATE_COMMUNITY_ITEM_STATUS_SUCCESS =
  'UPDATE_COMMUNITY_ITEM_STATUS_SUCCESS';
export const UPDATE_COMMUNITY_ITEM_STATUS_FAILURE =
  'UPDATE_COMMUNITY_ITEM_STATUS_FAILURE';
export const REMOVE_POST_REQUEST = 'REMOVE_POST_REQUEST';
export const REMOVE_POST_SUCCESS = 'REMOVE_POST_SUCCESS';
export const REMOVE_POST_FAILURE = 'REMOVE_POST_FAILURE';
export const SUBMIT_POST_REQUEST = 'SUBMIT_POST_REQUEST';
export const SUBMIT_POST_SUCCESS = 'SUBMIT_POST_SUCCESS';
export const SUBMIT_POST_FAILURE = 'SUBMIT_POST_FAILURE';

export const ADD_MESSAGE_SELLER_REQUEST = 'ADD_MESSAGE_SELLER_REQUEST';
export const ADD_MESSAGE_SELLER_SUCCESS = 'ADD_MESSAGE_SELLER_SUCCESS';
export const ADD_MESSAGE_SELLER_FAILURE = 'ADD_MESSAGE_SELLER_FAILURE';

export const GET_POSTS_COMMENTS_LIST_REQUEST =
  'GET_POSTS_COMMENTS_LIST_REQUEST';
export const GET_POSTS_COMMENTS_LIST_SUCCESS =
  'GET_POSTS_COMMENTS_LIST_SUCCESS';
export const GET_POSTS_COMMENTS_LIST_FAILURE =
  'GET_POSTS_COMMENTS_LIST_FAILURE';
export const CREATE_POST_COMMENT_REQUEST = 'CREATE_POST_COMMENT_REQUEST';
export const CREATE_POST_COMMENT_SUCCESS = 'CREATE_POST_COMMENT_SUCCESS';
export const CREATE_POST_COMMENT_FAILURE = 'CREATE_POST_COMMENT_FAILURE';
export const TOGGLE_POST_LIKE_REQUEST = 'TOGGLE_POST_LIKE_REQUEST';
export const TOGGLE_POST_LIKE_SUCCESS = 'TOGGLE_POST_LIKE_SUCCESS';
export const TOGGLE_POST_LIKE_FAILURE = 'TOGGLE_POST_LIKE_FAILURE';
export const GET_REMOTE_DOORMAN_CALLS_REQUEST =
  'GET_REMOTE_DOORMAN_CALLS_REQUEST';
export const GET_REMOTE_DOORMAN_CALLS_SUCCESS =
  'GET_REMOTE_DOORMAN_CALLS_SUCCESS';
export const GET_REMOTE_DOORMAN_CALLS_FAILURE =
  'GET_REMOTE_DOORMAN_CALLS_FAILURE';
export const GET_REMOTE_DOORMAN_CALL_REQUEST =
  'GET_REMOTE_DOORMAN_CALL_REQUEST';
export const GET_REMOTE_DOORMAN_CALL_SUCCESS =
  'GET_REMOTE_DOORMAN_CALL_SUCCESS';
export const GET_REMOTE_DOORMAN_CALL_FAILURE =
  'GET_REMOTE_DOORMAN_CALL_FAILURE';
export const CREATE_POP_UP_REQUEST = 'CREATE_POP_UP_REQUEST';
export const CREATE_POP_UP_SUCCESS = 'CREATE_POP_UP_SUCCESS';
export const CREATE_POP_UP_FAILURE = 'CREATE_POP_UP_FAILURE';
export const UPDATE_POP_UP_REQUEST = 'UPDATE_POP_UP_REQUEST';
export const UPDATE_POP_UP_SUCCESS = 'UPDATE_POP_UP_SUCCESS';
export const UPDATE_POP_UP_FAILURE = 'UPDATE_POP_UP_FAILURE';
export const DELETE_POP_UP_PHOTO_REQUEST = 'DELETE_POP_UP_PHOTO_REQUEST';
export const DELETE_POP_UP_PHOTO_SUCCESS = 'DELETE_POP_UP_PHOTO_SUCCESS';
export const DELETE_POP_UP_PHOTO_FAILURE = 'DELETE_POP_UP_PHOTO_FAILURE';
export const DELETE_POP_UP_REQUEST = 'DELETE_POP_UP_REQUEST';
export const DELETE_POP_UP_SUCCESS = 'DELETE_POP_UP_SUCCESS';
export const DELETE_POP_UP_FAILURE = 'DELETE_POP_UP_FAILURE';
export const GET_POP_UPS_REQUEST = 'GET_POP_UPS_REQUEST';
export const GET_POP_UPS_SUCCESS = 'GET_POP_UPS_SUCCESS';
export const GET_POP_UPS_FAILURE = 'GET_POP_UPS_FAILURE';

export const UPDATE_RD_DOORS_REQUEST = 'UPDATE_RD_DOORS_REQUEST';
export const UPDATE_RD_DOORS_SUCCESS = 'UPDATE_RD_DOORS_SUCCESS';
export const UPDATE_RD_DOORS_FAILURE = 'UPDATE_RD_DOORS_FAILURE';

export const GET_SERVICE_USERS_REQUEST = 'GET_SERVICE_USERS_REQUEST';
export const GET_SERVICE_USERS_SUCCESS = 'GET_SERVICE_USERS_SUCCESS';
export const GET_SERVICE_USERS_FAILURE = 'GET_SERVICE_USERS_FAILURE';
export const GET_CALL_CENTER_AGENTS_REQUEST = 'GET_CALL_CENTER_AGENTS_REQUEST';
export const GET_CALL_CENTER_AGENTS_SUCCESS = 'GET_CALL_CENTER_AGENTS_SUCCESS';
export const GET_CALL_CENTER_AGENTS_FAILURE = 'GET_CALL_CENTER_AGENTS_FAILURE';
export const GET_CALL_CENTER_AGENTS_LOG_REQUEST =
  'GET_CALL_CENTER_AGENTS_LOG_REQUEST';
export const GET_CALL_CENTER_AGENTS_LOG_SUCCESS =
  'GET_CALL_CENTER_AGENTS_LOG_SUCCESS';
export const GET_CALL_CENTER_AGENTS_LOG_FAILURE =
  'GET_CALL_CENTER_AGENTS_LOG_FAILURE';

export const CREATE_CALL_CENTER_AGENT_REQUEST =
  'CREATE_CALL_CENTER_AGENT_REQUEST';
export const CREATE_CALL_CENTER_AGENT_SUCCESS =
  'CREATE_CALL_CENTER_AGENT_SUCCESS';
export const CREATE_CALL_CENTER_AGENT_FAILURE =
  'CREATE_CALL_CENTER_AGENT_FAILURE';
export const DELETE_CALL_CENTER_AGENT_REQUEST =
  'DELETE_CALL_CENTER_AGENT_REQUEST';
export const DELETE_CALL_CENTER_AGENT_SUCCESS =
  'DELETE_CALL_CENTER_AGENT_SUCCESS';
export const DELETE_CALL_CENTER_AGENT_FAILURE =
  'DELETE_CALL_CENTER_AGENT_FAILURE';

export const GET_TWILIO_TOKEN_REQUEST = 'GET_TWILIO_TOKEN_REQUEST';
export const GET_TWILIO_TOKEN_SUCCESS = 'GET_TWILIO_TOKEN_SUCCESS';
export const GET_TWILIO_TOKEN_FAILURE = 'GET_TWILIO_TOKEN_FAILURE';
export const VERIFY_PHONE_NUMBER_REQUEST = 'VERIFY_PHONE_NUMBER_REQUEST';
export const VERIFY_PHONE_NUMBER_SUCCESS = 'VERIFY_PHONE_NUMBER_SUCCESS';
export const VERIFY_PHONE_NUMBER_FAILURE = 'VERIFY_PHONE_NUMBER_FAILURE';

export const PIN_BUILDING = 'PIN_BUILDING';
export const UNPIN_BUILDING = 'UNPIN_BUILDING';

export const REQ_CANCELED = 'REQ_CANCELED';

export const GET_COURIER_ERROR_REPORT_REQUEST =
  'GET_COURIER_ERROR_REPORT_REQUEST';
export const GET_COURIER_ERROR_REPORT_SUCCESS =
  'GET_COURIER_ERROR_REPORT_SUCCESS';
export const GET_COURIER_ERROR_REPORT_FAILURE =
  'GET_COURIER_ERROR_REPORT_FAILURE';
export const CREATE_COURIER_ERROR_REQUEST = 'CREATE_COURIER_ERROR_REQUEST';
export const CREATE_COURIER_ERROR_SUCCESS = 'CREATE_COURIER_ERROR_SUCCESS';
export const CREATE_COURIER_ERROR_FAILURE = 'CREATE_COURIER_ERROR_FAILURE';

export const CLEAR_STAFF_LOG_POSTS = 'CLEAR_STAFF_LOG_POSTS';

export const GET_STAFF_LOG_POSTS_REQUEST = 'GET_STAFF_LOG_POSTS_REQUEST';
export const GET_STAFF_LOG_POSTS_SUCCESS = 'GET_STAFF_LOG_POSTS_SUCCESS';
export const GET_STAFF_LOG_POSTS_FAILURE = 'GET_STAFF_LOG_POSTS_FAILURE';

export const CREATE_STAFF_LOG_POST_REQUEST = 'CREATE_STAFF_LOG_POST_REQUEST';
export const CREATE_STAFF_LOG_POST_SUCCESS = 'CREATE_STAFF_LOG_POST_SUCCESS';
export const CREATE_STAFF_LOG_POST_FAILURE = 'CREATE_STAFF_LOG_POST_FAILURE';

export const CREATE_STAFF_LOG_COMMENT_REQUEST =
  'CREATE_STAFF_LOG_COMMENT_REQUEST';
export const CREATE_STAFF_LOG_COMMENT_SUCCESS =
  'CREATE_STAFF_LOG_COMMENT_SUCCESS';
export const CREATE_STAFF_LOG_COMMENT_FAILURE =
  'CREATE_STAFF_LOG_COMMENT_FAILURE';

export const GET_STAFF_LOG_COMMENTS_LIST_REQUEST =
  'GET_STAFF_LOG_COMMENTS_LIST_REQUEST';
export const GET_STAFF_LOG_COMMENTS_LIST_SUCCESS =
  'GET_STAFF_LOG_COMMENTS_LIST_SUCCESS';
export const GET_STAFF_LOG_COMMENTS_LIST_FAILURE =
  'GET_STAFF_LOG_COMMENTS_LIST_FAILURE';

export const REMOVE_STAFF_LOG_COMMENT_REQUEST =
  'REMOVE_STAFF_LOG_COMMENT_REQUEST';
export const REMOVE_STAFF_LOG_COMMENT_SUCCESS =
  'REMOVE_STAFF_LOG_COMMENT_SUCCESS';
export const REMOVE_STAFF_LOG_COMMENT_FAILURE =
  'REMOVE_STAFF_LOG_COMMENT_FAILURE';

export const GET_STAFF_LOG_POST_REQUEST = 'GET_STAFF_LOG_POST_REQUEST';
export const GET_STAFF_LOG_POST_SUCCESS = 'GET_STAFF_LOG_POST_SUCCESS';
export const GET_STAFF_LOG_POST_FAILURE = 'GET_STAFF_LOG_POST_FAILURE';

export const REMOVE_STAFF_LOG_POST_REQUEST = 'REMOVE_STAFF_LOG_POST_REQUEST';
export const REMOVE_STAFF_LOG_POST_SUCCESS = 'REMOVE_STAFF_LOG_POST_SUCCESS';
export const REMOVE_STAFF_LOG_POST_FAILURE = 'REMOVE_STAFF_LOG_POST_FAILURE';

export const SET_AMENITY_STATUS_REQUEST = 'SET_AMENITY_STATUS_REQUEST';
export const SET_AMENITY_STATUS_SUCCESS = 'SET_AMENITY_STATUS_SUCCESS';
export const SET_AMENITY_STATUS_FAILURE = 'SET_AMENITY_STATUS_FAILURE';

export const GET_DOORS_AMENITY_REQUEST = 'GET_DOORS_AMENITY_REQUEST';
export const GET_DOORS_AMENITY_SUCCESS = 'GET_DOORS_AMENITY_SUCCESS';
export const GET_DOORS_AMENITY_FAILURE = 'GET_DOORS_AMENITY_FAILURE';

export const REMOVE_COMMENT_FAILURE = 'REMOVE_COMMENT_FAILURE';
export const REMOVE_COMMENT_REQUEST = 'REMOVE_COMMENT_REQUEST';
export const REMOVE_COMMENT_SUCCESS = 'REMOVE_COMMENT_SUCCESS';

export const GET_FD_RESERVATIONS_REQUEST = 'GET_FD_RESERVATIONS_REQUEST';
export const GET_FD_RESERVATIONS_SUCCESS = 'GET_FD_RESERVATIONS_SUCCESS';
export const GET_FD_RESERVATIONS_FAILURE = 'GET_FD_RESERVATIONS_FAILURE';

export const GET_DETAILED_FD_RESERVATIONS_REQUEST =
  'GET_DETAILED_FD_RESERVATIONS_REQUEST';
export const GET_DETAILED_FD_RESERVATIONS_SUCCESS =
  'GET_DETAILED_FD_RESERVATIONS_SUCCESS';
export const GET_DETAILED_FD_RESERVATIONS_FAILURE =
  'GET_DETAILED_FD_RESERVATIONS_FAILURE';

export const GET_FD_EVENTS_REQUEST = 'GET_FD_EVENTS_REQUEST';
export const GET_FD_EVENTS_SUCCESS = 'GET_FD_EVENTS_SUCCESS';
export const GET_FD_EVENTS_FAILURE = 'GET_FD_EVENTS_FAILURE';

export const GET_EVENTS_LIST_REQUEST = 'GET_EVENTS_LIST_REQUEST';
export const GET_EVENTS_LIST_SUCCESS = 'GET_EVENTS_LIST_SUCCESS';
export const GET_EVENTS_LIST_FAILURE = 'GET_EVENTS_LIST_FAILURE';
export const CREATE_EVENT_FAILURE = 'CREATE_EVENT_FAILURE';
export const CREATE_EVENT_REQUEST = 'CREATE_EVENT_REQUEST';
export const CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
export const UPDATE_EVENT_REQUEST = 'UPDATE_EVENT_REQUEST';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_FAILURE = 'UPDATE_EVENT_FAILURE';
export const GET_EVENT_DATA_REQUEST = 'GET_EVENT_DATA_REQUEST';
export const GET_EVENT_DATA_SUCCESS = 'GET_EVENT_DATA_SUCCESS';
export const GET_EVENT_DATA_FAILURE = 'GET_EVENT_DATA_FAILURE';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';
export const DELETE_EVENT_FAILURE = 'DELETE_EVENT_FAILURE';
export const DELETE_EVENT_REQUEST = 'DELETE_EVENT_REQUEST';
export const GET_EVENT_RSVPS_SUCCESS = 'GET_EVENT_RSVPS_SUCCESS';
export const GET_EVENT_RSVPS_FAILURE = 'GET_EVENT_RSVPS_FAILURE';
export const GET_EVENT_RSVPS_REQUEST = 'GET_EVENT_RSVPS_REQUEST';
export const DELETE_EVENT_RSVP_REQUEST = 'DELETE_EVENT_RSVP_REQUEST';
export const DELETE_EVENT_RSVP_SUCCESS = 'DELETE_EVENT_RSVP_SUCCESS';
export const DELETE_EVENT_RSVP_FAILURE = 'DELETE_EVENT_RSVP_FAILURE';
export const DELETE_EVENT_RSVP_GUEST_REQUEST =
  'DELETE_EVENT_RSVP_GUEST_REQUEST';
export const DELETE_EVENT_RSVP_GUEST_SUCCESS =
  'DELETE_EVENT_RSVP_GUEST_SUCCESS';
export const DELETE_EVENT_RSVP_GUEST_FAILURE =
  'DELETE_EVENT_RSVP_GUEST_FAILURE';
export const GET_EVENT_RSVPS_FOR_FILTER_FAILURE =
  'GET_EVENT_RSVPS_FOR_FILTER_FAILURE';
export const GET_EVENT_RSVPS_FOR_FILTER_REQUEST =
  'GET_EVENT_RSVPS_FOR_FILTER_REQUEST';
export const GET_EVENT_RSVPS_FOR_FILTER_SUCCESS =
  'GET_EVENT_RSVPS_FOR_FILTER_SUCCESS';

export const CREATE_RSVP_FAILURE = 'CREATE_RSVP_FAILURE';
export const CREATE_RSVP_REQUEST = 'CREATE_RSVP_REQUEST';
export const CREATE_RSVP_SUCCESS = 'CREATE_RSVP_SUCCESS';
export const ADD_RSVP_GUEST_REQUEST = 'ADD_RSVP_GUEST_REQUEST';
export const ADD_RSVP_GUEST_SUCCESS = 'ADD_RSVP_GUEST_SUCCESS';
export const ADD_RSVP_GUEST_FAILURE = 'ADD_RSVP_GUEST_FAILURE';

export const CLEAR_EVENTS_STATE = 'CLEAR_EVENTS_STATE';

export const CREATE_HOME_FEED_CARD_FAILURE = 'CREATE_HOME_FEED_CARD_FAILURE';
export const CREATE_HOME_FEED_CARD_REQUEST = 'CREATE_HOME_FEED_CARD_REQUEST';
export const CREATE_HOME_FEED_CARD_SUCCESS = 'CREATE_HOME_FEED_CARD_SUCCESS';
export const UPDATE_HOME_FEED_CARD_FAILURE = 'UPDATE_HOME_FEED_CARD_FAILURE';
export const UPDATE_HOME_FEED_CARD_REQUEST = 'UPDATE_HOME_FEED_CARD_REQUEST';
export const UPDATE_HOME_FEED_CARD_SUCCESS = 'UPDATE_HOME_FEED_CARD_SUCCESS';
export const DELETE_HOME_FEED_CARD_FAILURE = 'DELETE_HOME_FEED_CARD_FAILURE';
export const DELETE_HOME_FEED_CARD_REQUEST = 'DELETE_HOME_FEED_CARD_REQUEST';
export const DELETE_HOME_FEED_CARD_SUCCESS = 'DELETE_HOME_FEED_CARD_SUCCESS';

export const GET_HOME_FEED_CARDS_FAILURE = 'GET_HOME_FEED_CARDS_FAILURE';
export const GET_HOME_FEED_CARDS_REQUEST = 'GET_HOME_FEED_CARDS_REQUEST';
export const GET_HOME_FEED_CARDS_SUCCESS = 'GET_HOME_FEED_CARDS_SUCCESS';

// TODO: doesn't exist on API; should be added later
export const GET_HOME_FEED_CARD_FAILURE = 'GET_HOME_FEED_CARD_FAILURE';
export const GET_HOME_FEED_CARD_REQUEST = 'GET_HOME_FEED_CARD_REQUEST';
export const GET_HOME_FEED_CARD_SUCCESS = 'GET_HOME_FEED_CARD_SUCCESS';

export const CREATE_YOUR_WELLBEING_CARD_FAILURE =
  'CREATE_YOUR_WELLBEING_CARD_FAILURE';
export const CREATE_YOUR_WELLBEING_CARD_REQUEST =
  'CREATE_YOUR_WELLBEING_CARD_REQUEST';
export const CREATE_YOUR_WELLBEING_CARD_SUCCESS =
  'CREATE_YOUR_WELLBEING_CARD_SUCCESS';
export const DELETE_YOUR_WELLBEING_CARD_FAILURE =
  'DELETE_YOUR_WELLBEING_CARD_FAILURE';
export const DELETE_YOUR_WELLBEING_CARD_REQUEST =
  'DELETE_YOUR_WELLBEING_CARD_REQUEST';
export const DELETE_YOUR_WELLBEING_CARD_SUCCESS =
  'DELETE_YOUR_WELLBEING_CARD_SUCCESS';
export const GET_YOUR_WELLBEING_CARDS_FAILURE =
  'GET_YOUR_WELLBEING_CARDS_FAILURE';
export const GET_YOUR_WELLBEING_CARDS_REQUEST =
  'GET_YOUR_WELLBEING_CARDS_REQUEST';
export const GET_YOUR_WELLBEING_CARDS_SUCCESS =
  'GET_YOUR_WELLBEING_CARDS_SUCCESS';
export const GET_YOUR_WELLBEING_CARD_FAILURE =
  'GET_YOUR_WELLBEING_CARD_FAILURE';
export const GET_YOUR_WELLBEING_CARD_REQUEST =
  'GET_YOUR_WELLBEING_CARD_REQUEST';
export const GET_YOUR_WELLBEING_CARD_SUCCESS =
  'GET_YOUR_WELLBEING_CARD_SUCCESS';
export const UPDATE_YOUR_WELLBEING_CARD_FAILURE =
  'UPDATE_YOUR_WELLBEING_CARD_FAILURE';
export const UPDATE_YOUR_WELLBEING_CARD_REQUEST =
  'UPDATE_YOUR_WELLBEING_CARD_REQUEST';
export const UPDATE_YOUR_WELLBEING_CARD_SUCCESS =
  'UPDATE_YOUR_WELLBEING_CARD_SUCCESS';

export const CREATE_BUILDING_GUIDE_CARD_FAILURE =
  'CREATE_BUILDING_GUIDE_CARD_FAILURE';
export const CREATE_BUILDING_GUIDE_CARD_REQUEST =
  'CREATE_BUILDING_GUIDE_CARD_REQUEST';
export const CREATE_BUILDING_GUIDE_CARD_SUCCESS =
  'CREATE_BUILDING_GUIDE_CARD_SUCCESS';
export const UPDATE_BUILDING_GUIDE_CARD_FAILURE =
  'UPDATE_BUILDING_GUIDE_CARD_FAILURE';
export const UPDATE_BUILDING_GUIDE_CARD_REQUEST =
  'UPDATE_BUILDING_GUIDE_CARD_REQUEST';
export const UPDATE_BUILDING_GUIDE_CARD_SUCCESS =
  'UPDATE_BUILDING_GUIDE_CARD_SUCCESS';
export const DELETE_BUILDING_GUIDE_CARD_FAILURE =
  'DELETE_BUILDING_GUIDE_CARD_FAILURE';
export const DELETE_BUILDING_GUIDE_CARD_REQUEST =
  'DELETE_BUILDING_GUIDE_CARD_REQUEST';
export const DELETE_BUILDING_GUIDE_CARD_SUCCESS =
  'DELETE_BUILDING_GUIDE_CARD_SUCCESS';

export const GET_BUILDING_GUIDE_CARDS_FAILURE =
  'GET_BUILDING_GUIDE_CARDS_FAILURE';
export const GET_BUILDING_GUIDE_CARDS_REQUEST =
  'GET_BUILDING_GUIDE_CARDS_REQUEST';
export const GET_BUILDING_GUIDE_CARDS_SUCCESS =
  'GET_BUILDING_GUIDE_CARDS_SUCCESS';

// TODO: doesn't exist on API; should be added later
export const GET_BUILDING_GUIDE_CARD_FAILURE = 'GET_HOME_FEED_CARD_FAILURE';
export const GET_BUILDING_GUIDE_CARD_REQUEST = 'GET_HOME_FEED_CARD_REQUEST';
export const GET_BUILDING_GUIDE_CARD_SUCCESS = 'GET_HOME_FEED_CARD_SUCCESS';
